/* eslint-disable max-len */
const en = {
    duplicate_denounce_warning: "There is already an active complaint",
    duplicate_denounce_cannot_report: "For now, you cannot report this listing.",
    no_can_report_massively_catalog_product: "It's not possible to report in bulk because it's a Catalog product.",
    onboarding_slide_notices: {
        step_1: {
            title: "Check the new features!",
            description:
                "Now It is easier to translate the section, view the attached documentation and the details of the reported listing.",
        },
        step_2: {
            title: "Instant translation",
            description:
                "Translate all the content of the section with just one click.",
        },
        step_3: {
            title: "Documentation at a glance",
            description:
                "Preview the images attached by sellers without having to download them.",
        },
        step_4: {
            title: "Listing details",
            description:
                "Review the listing you reported in the new module at the end of the section.",
        },
        next: "Next",
        ok: "Got it",
    },
    catalogue: "catalogue",
    catalogue_id: "catalogue ID",
    official_store: "Official store",
    international_purchase: "INTERNATIONAL PURCHASE",
    article_catalogue_detail: {
        title_images: "Catalog photos",
        report_images: "Mark photos as suspicious",
        report_right: "Report an infringement of my rights",
        article_denounced: "Esta publicación infrige mis derechos",
        sellers_title: "Participating sellers",
        sellers_subtitle:
            "In order to mark a listing as suspicious, click on the corresponding seller's card.",
        seller_generic_response_title: "Seller's counter-notices",
        seller_generic_response_subtitle:
            "Here you will see the counter-notices of the seller you selected from the list of participants.",
        seller_response_title: "{seller_name}'s counter-notice",
        seller_response_subtitle:
            "Explore the counter-notices of the seller you selected to check if there are other reasons for suspicion.",
        seller_response_title_empty: "Seller's counter-notices",
        seller_response_subtitle_empty:
            "The seller you selected has not yet answered any questions.",
        seller_history: "View seller's history",
        seller_sales: "Sales",
        country_search: "Start the search in",
        newness_box: {
            title: "This is a Catalog listing",
            subtitle:
                "This is a page that groups, under a single content, different listings of the same product offered by different sellers.",
            "item1-a": "To report the photos in the listing,",
            "item1-b":
                "select the 'Mark as suspicious' option in the section that displays the product details.",
            "item2-a": "To report a listing from a specific seller,",
            "item2-b":
                "check the 'Participating sellers' column and click on the 'Mark as suspicious' button.",
            button: "Learn more",
            close: "Close",
        },
        sort_sellers: {
            item1: "A-Z",
            item2: "Price from lowest to highest",
            item3: "Price from highest to lowest",
            item4: "Official stores first",
        },
        seller_responses_search: "Search in answers...",
    },
    messageBox: {
        title: "Hello!",
        subtitle:
            "We would like to know how your experience with the reporting tool was. ",
        subtitleStrong: "Would you have 3 minutes to tell us?",
        button1: "Yes, sure",
        button2: "I have already answered",
    },
    multiple_denounce: {
        title: "Report request",
        instruction: "Select the type of infringement that applies to the products you want to report.",
        infraction_label: "Infraction",
        infraction_placeholder: "Select the infringement type",
        error_loading_infractions: "Error loading infringement type",
        error_detail_empty: "Error loading infringement detail",
        detail_label: "Detail",
        detail_placeholder: "Include the infringement details.",
        send_denounce: "Send report",
        mark_as_suspicious: "Mark as suspicious",
        cancel: "Cancel",
        table: {
            product: "Product",
            country: "Country",
            remove_from_selection: "Remove from selection",

        },
        options: {
            no_selected: "Select the type of infringement",
            report_code: {
                PPPI1: "Counterfeit product",
                PPPI2: "Unauthorized use of trademark",
                PPPI3: "Copyright - Software",
                PPPI5: "Copyright - Books",
                PPPI6: "Copyright - Images",
                PPPI7: "Copyright - Personal Image",
                PPPI8: "Industrial Design or Model",
                PPPI9: "Infringes patents, utility models or plant breeder's rights",
                PPPI10: "Product not destined for sale",
                PPPI11: "Copyright - Courses",
                PPPI12: "Copyright - Video games",
                PPPI14: "Copyright - Videos / Movies",
                PPPI15: "Copyright - Music",
                PPPI16: "Copyright - Characters",
                PPPI17: "Copyright - Others",
                PPPI18: "Related Rights - Illegal Reproductions",
                PPPI19: "Related Rights - Personal Image",
                PPPI20: "Related Rights - Audio Material",
                PPPI21: "Related Rights - Audiovisual Material",
                PPPI22: "Related Rights - Illegal Transmission",
                PPPI23: "Related Rights - Illegal Device",
                ACUERDO: "I have a regulatory agreement on this product.",

            },
        },
        progress: {
            processing: "Processing reports...",
            processed: "Processed",
            remaining: "Pending",
            finishing: "Finishing...",
            completed: "Process completed",
            summary: "Summary",
            successful: "Successful",
            failed: "Failed",
        },
    },
    memberJudge: {
        widget: {
            quality: "Compliance with best practices:",
            excelent: "excellent",
            good: "good",
            regular: "fair",
            critic: "critical",
            neutral: "no data",
        },
        tooltip: {
            excelent: {
                title: "Your reports are accurate!",
                subtitle: "Your reports help us to safeguard the buyer’s experience and protect your intellectual property rights. ",
            },
            excelentWithRestriction: {
                title: "The number of reports you can make may be limited",
                subtitle:
                    "Although in most of your reports you follow the process as indicated, some have not been carried out correctly. Avoid this behavior to prevent additional sanctions.",
            },
            good: {
                title: "You have an opportunity to improve your reports",
                subtitle:
                    "Most of your reports are based on intellectual property infringements and you follow the process as indicated, but some have not been carried out correctly",
            },
            goodWithRestriction: {
                title: "You have an opportunity to improve your reports",
                subtitle: "Some of your reports have not been carried out correctly. Avoid this behavior to prevent further sanctions. ",
            },
            regular: {
                title: "You must improve your reports",
                subtitle:
                    "Make sure to always comply with the best practices of the BPP when sending a report and to follow the process as indicated.  ",
            },
            regularWithRestriction: {
                title: "You must improve your reports",
                subtitle: "Make sure to always comply with the best practices of the BPP when sending a report and to follow the process as indicated in order to avoid further sanctions.",
            },
            critic: {
                title: "You are not complying with the best practices of the BPP",
                subtitle: "Only send reports related to intellectual property infringements and avoid the improper use of the program.",
            },
            criticWithRestriction: {
                title: "You are not complying with the best practices of the BPP",
                subtitle: "Only send reports related to intellectual property infringements and avoid the improper use of the program.",
            },
            neutral: {
                title: "You have not reported a sufficient number of listings",
                subtitle: "When you send a report, we can help you if needed.",
            },
            neutralWithRestriction: {
                title: "You have not reported a sufficient number of listings",
                subtitle: "When you send a report, we can help you if needed.",
            },
        },
        button2: "Check reports",
        alerts: {
            know_more: "Learn more",
            new_member: {
                title: "Send up to 50 reports per day",
                subtitle:
                    "To ensure that you learn to use the program correctly, and in accordance with your enrolled rights, you will be allowed to make up to 50 reports per day.",
                subtitle2: "When you reach the limit, you will only be able to mark listings as suspicious. ",
                subtitle3: "This measure will be temporary if you complete the reporting process correctly. ",
                subtitle3Strong_s: "You have {number} report today",
                subtitle3Strong_p: "You have {number} reports today",
            },
            sleepy: {
                title: "Send up to 50 reports per day",
                subtitle:
                    "As your account has not been used for an extended period, we want to ensure that you can send accurate reports based on your enrolled rights. As a result, you will be allowed to send up to 50 reports per day.  ",
                subtitleStrong: "When you reach the limit, you will only be able to mark listings as suspicious",
                subtitle2: "This measure will be temporary if you complete the reporting process correctly.",
                subtitle2Strong_s: "You have {number} report today",
                subtitle2Strong_p: "You have {number} reports today",
            },
            restricted: {
                title: "You have been limited to 50 reports per day",
                subtitle:
                    "The efficiency of your reports is  critical because you did not complete the process in accordance with the Brand Protection Program guidelines. ",
                subtitle2: "When you reach the limit of reports, you will only be able to mark listings as suspicious.",
                subtitle2Strong_s: "You have {number} report today",
                subtitle2Strong_p: "You have {number} reports today",
            },
            prevent: {
                title: "Send accurate reports and avoid potential sanctions on your BPP account",
                subtitle: "Upon reviewing your reports, we found that you may not be complying with our ",
                subtitle_link: "best practices",
                subtitle2: " Send accurate reports; otherwise,",
                subtitle2Strong: " your use of the BPP reporting tool may be restricted or you may be temporarily suspended from the program",
                subtitle3: "Follow our recommendations and learn how to take full advantage of your account.",
                checkReport: "Review reports",
            },
            restriction: {
                title: "We temporarily limited your number of reports to {max_denounces} per day",
                subtitle: "Due to reporting listings for reasons other than intellectual property rights infringements, you are not complying with our ",
                subtitle_link: "best practices",
                subtitle2: "As a result, you are limited to a maximum of {max_denounces} ",
                subtitle2_b: "reports per day until {date}. ",
                subtitle2Strong_s: "You have {number} report today",
                subtitle2Strong_p: "You have {number} reports today",
                subtitle3: "Send accurate reports and be aware that repeating this behavior ",
                subtitle3Strong: "could result in further limitations on your use of the BPP reporting tool or temporary suspension from the program",
                subtitle4: " If you need help or want us to review your case, ",
                subtitle4_link: "contact us",
            },

            limitation: {
                title: "Your BPP account was temporarily suspended for {days} days",
                subtitle: "Due to reporting listings repeatedly for reasons other than intellectual property rights infringements, you are not complying with our ",
                subtitle_link: "best practices",
                subtitle2: " As a result, ",
                subtitle2Strong: "you will be unable to send new reports until {date}",
                subtitle3: "Send accurate reports and be aware that repeating this behavior ",
                subtitle3Strong: "could result in another suspension from the program",
                subtitle4: " If you need help or want us to review your case, ",
                subtitle4_link: "contact us",
            },
            suspension: {
                title: "Your BPP account for sending reports was suspended",
                subtitle: "It was detected that you have infringed our ",
                subtitle_link: "Terms and Conditions",
                subtitle2: " by repeatedly reporting listings that fall beyond the scope of the Brand Protection Program (BPP). As a result,  ",
                subtitle2Strong: "your account for sending reports will be suspended until you contact us",
                subtitle3: "Please note that you will only be able to: ",
                subtitle3_a: "Access your reports history or generate new reports. ",
                subtitle3_b: "Use your account to contact us via the form.",
                subtitle4: "Review your reports and if you need help or want us to review your case,",
                subtitle4_link: "contact us",
            },
        }
    },
    efficiency: {
        title: "Account efficiency",
        default:
            "We do not have enough data to assess your account efficiency. \n",
        high: "Your account efficiency is very high. Good job! .\n",
        med: "Be careful, your account is at risk of being restricted. \n",
        risk: " Your account is restricted. Review your efficiency level and understand the reasons for the restriction. ",
        subtitle: "Check out efficiency. ",
        subtitle2: "Learn more.",
    },
    blindage: {
        tooltip_title: "You already reported this listing before",
        tooltip_content:
            "We detected that you already reported this listing due to the same infringement and decided to withdraw the report. To report it again, inform us if you found a different infringement. Otherwise, you will be able to report it as from ",
        tooltip_link: "Contact us",
        modal_excel: {
            title: "List of suspicious listing sent",
            subtitle_errors: "Some of the listing you imported have errors.",
            subtitle_success: `You'll be able to check the imported elements from the "Suspicious listings" section".`,
            subtitle_success_mark_suspicious: "Done! You marked the products as suspicious.",
            notBlindages_found: "listings to report",
            notBlindage_found: "listing to report",
            blindages_found: "listings that could not be processed",
            blindage_found: "listing that could not be processed",
            blindages_found2: "Your listings could not be processed",
            blindage_found2: "Your listing could not be processed",
            blindage_content:
                "We noticed that you had already reported these listings based on the same infringement and had chosen to withdraw the report.",
        },
        modal_multiple: {
            title: "Suspicious listings selected",
            subtitle_success: `You'll be able to checkthe selected elements successfully from the "Suspicious listings" section`,
            subtitle_errors: `Some of the listings you selected have errors. You'll be able to checkthe selected elements successfully from the "Suspicious listings" section`,
            elements: "selected elements",
            element: "selected element",
            notBlindages_found: "listings selected successfully",
            notBlindage_found: "listing selected successfully",
            blindages_found: "listings that could not be processed",
            blindage_found: "listing that could not be processed",
        },
    },
    noData: {
        title: "Nothing here...",
        subtitle: "When you report listings, you will be able to find them here.",
    },
    UP: {
        offer_variants: "The seller is offering ",
        variants: "{0} variations",
        offer_variants_b: " of this product. ",
        no_forget: "Don’t forget to review them.",
        check_variants: "Review variations",
        suspect_btn: "Mark as suspicious",
        denounced_images: "Report images",
        seller: "Seller",
        sales: "+ {sales} sales",
        conditions: {
            title: "Selling conditions",
            subtitle: "Check the different conditions that the seller offers for this variation.",
            alert: "Please note that if you use bulk selection to report Catalog selling conditions, certain infringements won’t apply. To report these selling conditions, go to the main page of each one and submit your report there."
        },
        table: {
            title: "Variations",
            subtitle: "These are all the product variations offered by the seller.",
            selected: "selected",
            selected_p: "selected",
            more_conditions: "All selling conditions",
            check_variant: "Review variation",
            tooltip: "You already marked this listing as suspicious. "
        },
    },
    Kits: {
        check_kits: "Review kit products",
        check_product: "Review product",
        count: "{count} products on the kit",
        alert: {
            title: "You can report products that are part of the kit",
            subtitle: "When reporting a product that infringes your intellectual property rights, the kits in which it's sold will also be affected."
        },
        table: {
            title: "Products that are part of the kit",
            subtitle: "These are all the products that are part of the kit."
        }
    },
    similar: "LISTING GROUP",
    Similar: {
        check_similar: "Check listing",
        check_similars: "Check similar listings",
        sellers_history: "Check seller history",
        see_alls: "Check all similar listings",

        alert: {
            title: "There are {0} other listings similar to this one",
            subtitle: "Other sellers offer products like this. Check if their listings infringe your intellectual property."
        },
        table: {
            title: "Similar listings",
            subtitle: "Listings from other sellers similar to",
            publication: "Listing",
            seller: "Seller",
            review: "Check listing"
        },
        search: {
            title: "Similar listings",
            subtitle: "Listings from other sellers similar to "
        }
    },
    "description-text": "Description",
    "attributes-text": "Characteristics",
    today: "today",
    tomorrow: "tomorrow",
    "see-details-denounced-onboarding": "Check the details",
    "see-details-denounced-onboarding-description":
        "Access the reported listing and remember the reason for each report.",
    "denounced-details-analyce-onboarding": "Review the counter notice",
    "denounced-details-check-onboarding":
        "Review the changes made by the seller, their documents and report history.",
    "denounced-detail-send-answer-onboarding": "Send your response",
    "denounced-detail-send-answer-onboarding-description":
        "Confirm or retract your report after reviewing the seller's response.",
    "redesigned-the-section": "We redesigned the section!",
    "redesigned-the-section-description":
        "Now it is easier to analyze each answer.",
    "your-denounced-ordered": "Your reports well organized",
    "your-denounced-ordered-description":
        "The reports that expire soon appear first so that nothing is missed.",
    "your-answers-informed": "Analyze all the details",
    "your-answers-informed-description":
        "Check the details of the report and the seller's counter notice in the same place.",
    "complaint-management": "Complaint management",
    "complaint-management-answer":
        "Here you will be able to follow the status of your complaints and respond to sellers to decide whether you want to confirm or retract your complaint.",
    "answers-to-be-reviewed": "Answers to be reviewed",
    "answers-to-be-reviewed-answer":
        "It shows a table with all the complaints where you have received a response from the seller. Click on the 'Analyze Response' button to view their details.",
    "analyze-response": "Analyze response",
    "analyze-response-answer":
        "Here you will see the details of the report you made, as well as the details of the seller who published the product you reported.",
    "analyze-response-answer-two":
        "In this section you can see the comments or attachments that the seller sent you in response.",
    "complaint-management-image-1": "pending_notices_EN.jpg",
    "complaint-management-image-2": "pending_notices_res_EN.jpg",
    "detail-answer-positive-one": "If you think their answer is sufficient",
    "detail-answer-positive-two":
        "and you want to cancel your report, you must retract your report.",
    "detail-answer-negative-one":
        "If you consider that the seller's response is insufficient,",
    "detail-answer-negative-two":
        "you must confirm your report. In this case, we will also ask you to select the reason why you rejected the seller's response.",
    "closed-complaints": "Closed complaints",
    "closed-complaints-answer":
        "Here you can consult the history of your closed complaints. Closed reports are those that end because you have already responded to the seller, because we have rejected it or because we have already terminated the seller or the publication.",
    "publication-detail-text": "Listing details",
    "comment-pending": "Comment",
    "optional-option": "Optonal",
    "send-answer-pending": "Send reply",
    pending_textarea_placeholder:
        "Give the seller more details about your decision.",
    "comment-detail-pending":
        "Review the seller's counter-notice before making your decision.",
    "answer-for-seller": "Answer for the seller",
    "confirm-report": "Confirm report",
    "retract-report": "Withdraw report",
    "reason-for-confirmation": "Reason for confirmation",
    "incorrect-documentation":
        "The documentation does not correspond to the reported product",
    "unreadable-documentation": "Documentation is unreadable",
    "unauthorized-user-document": "You are not authorized to use this content",
    "does-not-justify-stock": "Does not justify stock",
    "counterfeited-buy": "Make a purchase and it's counterfeit",
    "luxury-product-with-a-lot-stock":
        "It is a luxury product with too much stock",
    "low-average-price": "Priced below average",
    "comments-seller-null": "Seller made no comments",
    "list-to-back-closed-denounced": "See the list of closed reports",
    "list-to-back-pending-denounced": "See the list of pending reports",
    "list-to-back-noticed-denounced": "Back to list",
    "denounced-state": "Status of the complaint",
    rollbackeable: "I would like to reactivate this listing. ",
    "rollback-tooltip":
        "Mark this option if you would like to retract this report and reactivate the listing. ",
    "rollbackeable-description-title": "Retraction reason",
    "rollback-placeholder":
        "Please inform the reasons for retracting the report.",
    "rollback-case": "Reactivate listing",
    "rollback-success": "Done! The report was retracted. ",
    "rollback-error": "We were unable to save the changes. Please try again. ",
    "retracted-reason-title": "Retraction reason:",
    "see-documentation": "See documentation",
    "attached-documentation": "Attached documentation",
    "see-images-updated": "See modified images",
    "images-updated": "Edited images",
    "reported-images": "Reported images",
    "actual-images": "Current images",
    "commets-seller": "Seller's comment",
    "sellers-history": "Seller's history",
    "sellers-history-modal": {
        title: "Reports received by the seller",
        subtitle:
            "It is the history of the most recent reports received by this seller, from you as well as from other rights holders.",
        receive_s: "report received",
        receive_p: "reports received",
        receive_n: "No reports received",
        sent_s: "reply sent",
        sent_p: "reply sent",
        accepted_s: "reply accepted",
        accepted_p: "replies accepted",
        table: {
            th1: "Listing",
            th2: "Report Date",
            th3: "Report Reason",
            th4: "Seller’s reply",
        },
    },
    "translate-contents": "Translate contents",
    "answer-seller": "Seller's response",
    "see-ofert-auditor": "View auditor's commentary",
    "see-ofert-auditor-up": "Revisar comentario del auditor",
    "auditor-comment": "Auditor comment",
    "auditor-said": "said",
    "motif-denounced": "Reason for the complaint",
    "see-publication": "See denounced publication",
    "download-screenshot": "Download screenshot",
    "denounced-publication": "Denounced publication",
    "denounced-publications": "Denounced publications",
    "denounced-variants": "Reported variations",
    "denounced-variants-count": "You reported {count} variations of this product.",
    "send-answer-condition":
        "If you do not respond before the expiration date, the publication will be shown again in Mercado Libre",
    "send-answer": "Send your reply to the seller",
    "closed-title": "Closed report",
    "closed-subtitle":
        "You can check the details and retract your report, but you will not be able to communicate with the seller.",
    "rejected-title": "We were unable to process the report",
    "rejected-subtitle":
        "Review in the report status why we were unable to process it.",
    expires_text: "expires",
    "back-to-list": "Back to the list",
    "see-report": "see report",
    answer: "Submit counter-notice",
    see: "View",
    "analyse-response": "Analyze counter-notice",
    expires: "Expire",
    motif: "Reason",
    action: "Action",
    statusMsgPaused: "Paused listing",
    automation: {
        newbie: {
            title:
                "You have reached the limit of 50 daily reports. You will only be able to make a new report tomorrow ",
            text1:
                "The reason for this is because your account is new and we need to evaluate wheter the reports you made correspond to the rights you enrolled",
            text2: "Today you can only flag listings as suspicious ",
            button: "Learn more.",
        },
        newbieInfo: {
            title: "Your daily limit is 50 reports",
            text1:
                "This happens because your account is new and we need to check if the reports you made correspond to the rights you enrolled",
            text2: "You can still make {denounces} reports today.",
            text3:
                "After that you will only be able to flag listings as suspicious",
            button: "Learn more",
        },
        pending_cn: {
            title: "You have {30} counter-notices that expire today",
            text1:
                "You must review and respond to them in order to be able to keep reporting. Otherwise, the listings you reported will be automatically reactivated.",
            text2:
                "Remember that once received, you have 4 days to review the seller's counter-notice.",
            button: "Respond",
        },
        limited_by_inefficient: {
            with_denounces_p: {
                title: "Your account has been restricted to 50 daily reports",
                text1:
                    "This happens because the efficiency of your account is very low.",
                text2: "You can still make {number} reports today",
                text3:
                    "After that you will only be able to flag listings as suspicious.",
                button: "Learn more",
            },
            with_denounces_s: {
                title: "Your account has been restricted to 50 daily reports",
                text1:
                    "This happens because the efficiency of your account is very low.",
                text2: "You can still make {number} report today.",
                text3:
                    "After that you will only be able to flag listings as suspicious.",
                button: "Learn more",
            },
            without_denounces: {
                title: "You have reached your daily reports limit",
                text1: "Today you can only flag listings as suspicious",
                text2:
                    "We recommend you to review, in the efficiency section, the reasions why your account has been restricted.",
                button: "Learn more",
            },
            general: {
                text3: "Review your history to learn more.",
                button1: "Go to Report History",
                button2: "Learn more",
            },
            day_limit: {
                title:
                    "You won’t be able to make any more reports for the rest of the day",
                text1:
                    "You have already reported your daily maximum quantity of 30.000 listings.",
                text2:
                    "Please note that you can still mark listings as suspicious, but won’t be able to report them until tomorrow.",
            },
        },
        items_inactive: {
            case_1: "You can send only {50} reports today.",
            case_2: {
                text1: "You've already sent {20} of your {50} maximum daily reports.",
                text2: "There are {30} left.",
            },
            case_3: {
                text1:
                    "You've already reported your maximum daily number of {50} listings.",
                text2: "You cannot make any more reports for the rest of the day.",
            },
            tooltip:
                "We restricted your reports, because more than 60% were rejected in the last 2 months.",
        },
        generic: {
            title: "You cannot make any more reports",
            text: "Please note that you can mark listings as suspicious, but you will not be able to make the reports until {date}.",
        },
        tooltip_all: {
            title: "Would you like to send all reports?",
            body: "After you send them, we will notify the seller to send their counternotice.",
            ok: "Send reports",
            cancel: "Cancel",
        },
        tooltip_partial: {
            title_p: "You can only send {10} reports",
            title_s: "You can only send 1 report",
            body_1: "The listings you selected exceed your daily reporting limit, ",
            body_2: "however, you can send {10}.",
            ok_p: "Send {10} reports",
            ok_s: "Send 1 report",
            cancel: "Cancel",
        },
    },
    counter_notice_new_deadline_1:
        "We changed the deadlines to reply to sellers.",
    counter_notice_new_deadline_2:
        "Now you’ll have 4 days to review the counter-notices.",
    article_detail: {
        breadcrumb_label: "Item Detail",
        description: "Description",
        description_up: "Product description",
        questions: "Questions",
        empty_description:
            "The seller didn't add a description for this product.",
        back_to_results: "Back to results",
        back_to_suggested_listings: "Back to suggested listings",
        view_all_description: "View entire description",
        last_questions: "Latest questions",
        last_questions_catalogo: "Answers ",
        empty_questions: "Nobody asked any questions yet.",
        view_more_questions: "See more questions",
        marked_as_suspicious: "Listing marked as suspicious",
        motive: "Reason",
        marked_as_trusted: "Listing marked as trusted",
        by: "by",
    },
    mark_as_suspicious_label: "Suspicious",
    mark_as_trusted_label: "Trusted",
    mark_as_catalogo_label: "View details",
    original: "Orig",
    translation: "Translation",
    translate_click_here_original: "See original",
    translate_click_here_translated: "See translation",
    maintenance: {
        we_are_working: "We're working on new improvements!",
        come_back_soon: "Come back soon and log in again to check them out.",
        maintenance_in_progress: "We are performing maintenance tasks. We apologize for any inconvenience caused.",
    },
    all_auditors: "All auditors",
    there_are_not_listings_that_match: "No listing matches your search",
    view_more: "see more...",
    know_more: "Conoce más",
    view_more_suggested: "View more suggested",
    view_all: "View all",
    video_tutotial_link:
        "https://www.youtube.com/embed/pgPXVPHEfug?rel=0&amp;showinfo=0",
    title_snapshot_dowload: "Snapshot Download",
    snapshot_dowload_error:
        "There was an error while getting the download link, try again later.",
    snapshot_link_label: "Click here to download the snapshot",
    new_content_available: "New content available.",
    check_report_codes_for:
        "Make sure you have complaint codes for the following countries: ",
    no_report_codes_available_for:
        "You do not have report codes available for ",
    about_to_delete_live_search:
        "You are about to delete the following Livesearch:",
    activate_all: "Activate all",
    countries_toggle_info:
        "Click on the countries you wish to skip from your search. To exclude all, please use the button below.",
    authorize_btn: "Click here to authorize",
    message_authorize:
        "You still have to authorize the following countries to search and report on them",
    activate_none: "Deactivate all",
    expand: "Expand",
    collapse: "Collapse",
    activity: "Activity",
    activity_uppercase: "ACTIVITY",
    apply: "Apply",
    apply_filters: "Apply changes and update search",
    apply_filters_error:
        "We are Sorry but we couldn't apply filters. Please try again",
    applying_filters: "Applying filters",
    are_you_sure: "Are you sure?",
    question_send_all_notices: "Send notices to all?",
    article: "Listing",
    disabled_article: "deactivated post",
    article_change_status_error:
        "We are Sorry but but we couldn't change the status of the article.",
    article_change_status_error_already:
        "It was already audited inside your organization.",
    articles_change_status_error:
        "We are Sorry but but we couldn't change the status of the articles.",
    articles_change_status_error_already:
        "They were already audited inside your organization.",
    article_drop: "takedown",
    article_drops: "takedowns",
    article_from_white_seller: "Black listed seller",
    article_ok: "Product OK",
    article_invalid: "You can't report this listing",
    article_reference: "ID",
    article_brand_name: "Brand",
    article_part_name: "Part Number",
    article_type: "Article Type",
    article_without_picture: "PRODUCT WITHOUT PICTURE",
    in_moderation_card_title: "Report sent",
    in_moderation_card_text_1: "Check the status of your reports in the ",
    in_moderation_card_text_2: "Report History ",
    in_moderation_card_text_3: "section.",
    articles_to_ok_warn:
        "You are about to change the status of this Listing to OK. This action cannot be undone",
    articles_to_pending_warn:
        "You are about to change the status of this listing to 'Audit Pending'. All report information will be lost. Do you want to continue?",
    mark: "Mark",
    articles_to_report: "listings as suspicious",
    article_to_report: "listing as suspicious",
    articles_to_report_menu: "Report suspicious listings",
    articles_to_report_sub: "Review and send your reports.",
    articles_to_report_short: "Prods. to report",
    audited: "Audited",
    audited_batch_title: "Audited in batch selection mode",
    result: "Result",
    results: "Results",
    ready_to_audit: "READY TO AUDIT",
    available_quantity: "available",
    avoided_words: "Words to be excluded",
    batch_mode: "Batch mode",
    batch_mode_info:
        "Select several listings at once by activating Batch Mode, and clicking on the thumbs up or down.",
    deselect_current_page: "Deselect current page",
    deselect_all: "Deselect all",
    select_products_to_report_same_infringement: "Select products to report for the same infringement type.",
    selected_singular: "selected",
    selected_plural: "selected",
    brand: "Brand",
    brands: "Brands",
    ok: "Ok",
    accept: "Accept",
    cancel: "Cancel",
    cancel_batch_warning:
        "You're going to loose all your changes. Are you sure?",
    category: "Category",
    choose_another_brand: "Choose another brand",
    choose_brand: "Choose brand",
    condition_all: "All",
    condition_from_blacklisted_sellers: "From Blacklisted Sellers",
    condition_new: "New",
    condition_used: "Used",
    condition_refurbished: "Refurbished",
    "official-store": "Official Store Product",
    "switch-translate": {
        label: "Translate listing",
        tooltip: {
            title: "Translate this listing",
            description: "Activate our translator and analyze your report better.",
            button: "Got it",
        },
        tooltip_2: {
            title: "We deactivated this function while you report",
            description:
                "We have done it, so that you can analyze and mark violations about original texts.",
            button: "Got it",
        },
        snack_message: {
            title: "This is an automatic translation and it may contain mistakes",
            description:
                "Please note that the translations tool is a third-party service and should not be interpreted as an official translation. It’s only a suggestion and its use is not mandatory.",
        },
        error:
            "We had a problem and couldn’t load the translated text. Please try again.",
    },
    languages: {
        es: "Spanish",
        en: "English",
        pt: "Portuguese",
    },
    countries: {
        AA: "Global",
        AR: "Argentina",
        AT: "Austria",
        BE: "Belgium",
        BO: "Bolivia",
        BR: "Brazil",
        CA: "Canada",
        CH: "Switzerland",
        CL: "Chile",
        CO: "Colombia",
        CR: "Costa Rica",
        DE: "Germany",
        DO: "Dominican Republic",
        RD: "Dominican Republic",
        EC: "Ecuador",
        EN: "England",
        ES: "Espana",
        FR: "France",
        GB: "United Kingdom",
        GT: "Guatemala",
        HN: "Honduras",
        IE: "Ireland",
        IT: "Italy",
        MX: "Mexico",
        NI: "Nicaragua",
        NL: "Holland",
        PA: "Panama",
        PE: "Peru",
        PR: "Puerto Rico",
        PT: "Portugal",
        PY: "Paraguay",
        SC: "Scotland",
        SV: "El Salvador",
        US: "USA",
        UY: "Uruguay",
        VE: "Venezuela",
    },
    countries_legal: {
        AR: "Argentina",
        BO: "Bolivia",
        BR: "Brazil",
        CL: "Chile",
        CO: "Colombia",
        CR: "Costa Rica",
        DO: "Dominican",
        EC: "Ecuador",
        GT: "Guatemala",
        HN: "Honduras",
        MX: "Mexico",
        NI: "Nicaragua",
        PA: "Panama",
        PE: "Peru",
        PY: "Paraguay",
        SV: "El Salvador",
        UY: "Uruguay",
        VE: "Venezuela",
    },
    country: "Country",
    countries_select: "Countries",
    country_selector_clarification:
        "Select those countries in which you wish to search",
    all_the_countries: "All the countries",
    create_live_search_with_current_listings:
        "Create Livesearch with current listings",
    create_report_results: "Create Livesearch report",
    create_livesearch_report_created: "Report created successfully.",
    create_livesearch_report_error: "There was an error creating the report.",
    go_to_ls_reports: "Go to Livesearch reports",
    create_search_of_black_sellers:
        "Create Livesearch with current listings from all Blacklisted Sellers",
    creating: "creating",
    currency_report_results: "Select currency for report results",
    current_listings: "Active Listings",
    onboarding_slide: {
        skip: "Skip",
        start: "Start now",
        slide1: {
            title: "Before we start...",
            text: "Here are some tips so you can get the most out of our reporting tool.",
        },
        slide2: {
            title: "Perform massive searches",
            text: "Use the search field to find infringements in any Mercado Libre website.",
            image: "slide1-en.png",
        },
        slide3: {
            title: "Create your own search filters",
            text: "Customize your searches to find infractions easier and faster.",
            image: "slide2-en.png",
        },
        slide4: {
            title: "Multiple reports at the same time",
            text: "Report several listings from the same screen and in just a few clicks.",
            image: "slide3-en.png",
        },
        slide5: {
            title: "Send all your reports",
            text: "When you’re ready to send your reports, you can confirm one by one or all at once.",
            image: "slide4-en.png",
        },
        slide6: {
            title: "All done! Start reporting",
            text: "If you have any doubts, go to our Help section, from the menu on your left.",
        },
    },
    re_branding: {
        modal_title: "Now we are the Brand Protection Program of Mercado Libre",
        bullet_1: {
            title: "New name",
            subtitle:
                "The Intellectual Property Protection Program is now called the Brand Protection Program.",
        },
        bullet_2: {
            title: "New website",
            subtitle: "Now with more information and Frequently Asked Questions.",
        },
        bullet_3: {
            title: "The usual commitment",
            subtitle:
                "We continue working to improve the Program and make the reporting process even easier.",
        },
        check_out_what_is_new: "Check out what’s new!",
        go_to_bpp_site: "Go to site",
    },
    livesearch_onboarding: {
        title: "We simplify the process for reporting products",
        description: "Discover a new faster way with which you can also make your reports.",
        start_button: "Start",
    },
    livesearch_step_by_step: {
        of: "of",
        previous: "Previous",
        next: "Next",
        finish: "Finish",
        step1: {
            title: "Select the products to report",
            description: "Choose all that you consider are committing the same type of infraction.",
        },
        step2: {
            title: "Confirm your selection",
            description: "Once you have selected the products, you can report them all at once from the top bar.",
        },
    }, fotoproducto_tutorial: {
        intro: {
            title: "Now you can report product photography",
            description: "Select \"Product photography\" if you find photos showing your brand being used without authorization.",
            start_button: "Start",
        },
        step1: {
            title: "Select \"Product photography\"",
            description: "Choose this option to report images that use your brand without authorization.",
        },
        step2: {
            title: "Choose which the photos to report",
            description: "Check the listing and select any photos that use your brand without permission.",
        },
        step3: {
            title: "Fill out and submit your report",
            description: "Outline how your brand is used without permission and choose which document to add as supporting evidence.",
        },
        of: "of",
        previous: "Previous",
        next: "Next",
        finish: "Got it",
    },
    suggestions_slide: {
        next: "Next",
        start: "Got it",
        new_user: {
            slide1: {
                title: "A new way of reporting",
                text: "Analyze listings automatically detected, based on our processes and your reporting history.",
            },
            slide2: {
                title: "The more you analyze, the better suggestions will be",
                text: "We learn from your reportings in order to keep improving our detections and update your recommendations.",
            },
            slide3: {
                title: "New! Filter per country and keep reporting",
                text: "Find suggested listings in countries you are interested in and observe the progress of your last week's reportings.",
            },
        },
        old_user: {
            tag_text: "New!",
            slide1: {
                title: "Filter per country and keep reporting",
                text: "Find suggested listings in countries you are interested in and observe the progress of your last week's reportings.",
            },
        },
    },
    verify_profile: {
        title: "Update your account details",
        subtitle:
            "In order for us to continue to process your reports correctly, we need you to update your information.",
        expires: "You have until",
        verify_btn: "Update details",
        remind_later: "Remind me later",
        alert: {
            main_text: "Update your account details.",
            secondary_text:
                "Make sure your information is complete, so that we can continue to process your reports.",
            review_data: "Update details",
        },
        form: {
            title: "Account details",
            subtitle: "Update your account details. Please note that ",
            subtitle_b: "you will not be able to edit after confirming them.",
            confirm: "Confirm",
            account_type: {
                verified_title: "User type",
                title: "What type of user do you want to register?",
                item_titular: "I am the rights holder or legal representative",
                helper_titular:
                    "That is, you are the owner or legal representative of the rights that you are going to register.",
                item_apoderado: "I am a representative of the rights",
                helper_apoderado:
                    "That is, you are a natural or legal person authorized by the owner of the rights to act on his behalf.",
            },
            attorney_accreditation: {
                title: "Accredit yourself as a representative",
                name: "Representative Name:",
                name_helper: "It can be a natural person or a company.",
                subtitle: "Owner contact details",
                subtitle_helper_1: "optional",
                subtitle_helper_2:
                    "It can be the brand protection manager or IP counsel.",
                contact_name: "Contact Name",
                email: "Email Address",
            },
            account_info: {
                title: "Account information",
                subtitle: "The rights holder is:",
                natural: "Natural person",
                legal: "Legal person",
                physical_fields: {
                    name: "Name and Last Name",
                    country: "Country",
                    type: "Identification type",
                    number: "Identification number",
                },
                legal_fields: {
                    name: "Name or Company Name",
                    country: "Country",
                    type: "Tax identification type",
                    number: "Tax identification number",
                },
            },
            attorney_contact: {
                title: "Representative Contact",
                helper:
                    "This is the data that we will use from Mercado Libre to contact the account representative or administrator.",
                name: "Name and Last Name",
                code: "International Code",
                tel: "Phone Number",
                tel_helper: "Include the Area Code.",
                email: "Business Email Address",
                email_ex: "For example, john.doe@yourcompany.com",
                lang: "Contact Language",
                lang_placeholder: "Select",
            },
            public_data: {
                title: "Public Details",
                helper:
                    "This is the information that we will send to the reported seller so that they can contact you once the reporting process is complete. Make sure to put the name of the brand or economic group so that the seller knows who is reporting it.",
                name: "Name to show",
                email: "Email Address",
                email_helper:
                    "It can be generic and it must not be an email already registered in Mercado Libre.",
            },
            exit_modal: {
                title: "Do you want to exit the form?",
                text: "If you leave the page, you must complete all the information again.",
                back: "Back",
                exit: "Exit",
            },
            success: {
                text: "Done! We have updated your details.",
            },
            error_email: {
                text: "The email address entered is already registered on Mercado Libre. Please try a different one.",
            },
        },
    },
    suggested_listings: {
        title: "Suggested Listings",
        subtitle_p:
            "In this section, you will see the listings we found based on our detection and your reporting history.",
        subtitle_s:
            "These are the listings we found based on our detection and your reporting history.",
        stats: {
            box_1: {
                text1_p: "listings to report",
                text1_s: "of analyzed listings",
                text2: "Report",
            },
            box_2: {
                text1: "Your progress along the 7 days",
                text2_p: "marked as suspicious",
                text2_s: "marked as suspicious",
                text3_p: "marked as trusted",
                text3_s: "marked as trusted",
                text4: "Evolution of complaints",
                text5: "today",
            },
            tooltip_p: "reported listings",
            tooltip_s: "to report",
        },
        item1s: "of analyzed listings",
        item2s: "marked as trusted",
        item3s1: "marked as suspicious",
        item3s2: "Report",
        item1p: "of analyzed listings",
        item2p: "marked as trusted",
        item3p1: "marked as suspicious",
        item3p2: "Report",
        not_results_title: "There are no more suggestions!",
        not_results_link_label: "Make a new search",
    },
    suggested_discard: {
        text_btn: "Discard listing",
        tooltip: {
            title: "Are you unsure about what to do?",
            description:
                "Now you can discard the listing, so that we no longer show it in your results.",
        },
        modal: {
            title: "Why would you like to discard this listing?",
            subtitle:
                "Remember that we will show it again in your search results if the seller changes it or receives new questions.",
            discard_item: {
                item1: "I am not sure that it has a violation",
                item2:
                    "The listing or product does not correspond to my registered rights",
                item3: "The listing or product is not relevant to my business",
                item4: "Other reason",
                item1_subtext:
                    "That is, you did not find precise evidence of a counterfeit product, intellectual property violations etc.",
                item2_subtext:
                    "That is, the rights you have do not enable you to report violations about this listing or product.",
                item3_subtext:
                    "That is, it is not the main focus of the brand or your operation.",
                item4_subtext: "",
            },
            step_2: {
                title: "Can you tell us a bit more?",
                subtitle: "(Optional)",
                placeholder: "Tell us why you want to discard the listing.",
                btn_text: "Discard listing",

            },
        },
        done_article_discarded:
            "Done! If the listing has changes, we will show it to you again.",
    },
    file_uploader: {
        formats: "Formats",
        maximum_size: "Maximum size",
    },
    xlsx_import_success: {
        done: "Done!",
        marked_listing: "You marked 1 listing as suspicious.",
        marked_listings: "You marked {0} listings as suspicious.",
        go_to_report: "Report",
    },
    add_suspicious_xlsx: {
        alert_easier: "Bulk reporting is easier now.",
        alert_info:
            "You can now submit a spreadsheet with all the listings you wish to report.",
        alert_btn_label: "Upload in bulk",
        tooltip_onboarding_title: "Do you need to import a list?",
        tooltip_onboarding_text:
            "Now you can download your Excel spreadsheet of suspicious listings in this section.",
        tootip_btn_title: "Download your spreadsheet here.",
        tootip_btn_text:
            "You will only be able to import files that you have downloaded here.",
        modal_title: "Import list of listings suspicious",
        modal_subtitle_text1:
            "Please note that you can only import files downloaded from this section.",
        modal_subtitle_text2: "Download your Excel file",
        btn_import: "Send file",
        elements: "imported elements",
        element: "imported element",
        listings_found: "listings successfully imported",
        listing_found: "listing successfully imported",
        errors: "Errors",
        error: "listing that could not be processed",
        listings_duplicated: "listings already marked as suspicious",
        listing_duplicated: "listing already marked as suspicious",
        editable_catalog_accepted: "editable catalog accepted",
        editable_catalogs_accepted: "editable catalogs accepted",
        pure_catalog_rejected: "catalog listing",
        pure_catalogs_rejected: "catalog listings",
        catalog_listings: "Catalog listings",
        download_detail: "Download the spreadsheet to verify the errors",
        process_results_title: "We processed correctly the uploaded data",
        found_count_label: "Quantity of listings that you can add: ",
        not_found_count_label: "Quantity of listings that we could not find: ",
        invalid_count_label: "Quantity of invalid ids: ",
        how_to_title: "How to assemble the list",
        how_to_bullet_1: "Include one listing per row.",
        how_to_bullet_2: "You can include either the listing ID or its URL.",
        how_to_bullet_3: "Add only listings from the same country.",
        how_to_bullet_4: "You can import a maximum of 1000 listings at a time.",
        how_to_bullet_5:
            "Make sure all listings share the same reporting reason.",
        how_to_important: "Important!",
        how_to_download: "Download example",
        processing: "Processing",
        empty_text: "Add file",
        empty_drag_text: "You can also drag them",
        on_drag_text: "Drop the file here to process it",
        drag_file_too_large: "File is too large",
        error_reading_file:
            "We could not check your listings. Please try again later.",
        only_duplicated_listings_message:
            "The listings are already marked as suspicious.",
        only_duplicated_listing_message:
            "The listing is already marked as suspicious.",
        not_enrolled_rigths_listings_message:
            "The listings are in a marketplace where you do not have enrolled rights.",
        not_enrolled_rigths_listing_message:
            "The listing is in a marketplace where you do not have enrolled rights.",
        not_valid_found_message:
            "We could not find listings with the IDs or URLs entered.",
        only_one_site: "The file contains listings from more than one country.",
        only_one_file: "You can’t send more than one file at a time.",
        incorrect_file_format: "This file has incorrect format.",
        too_many_message: "The file contains more than 1000 components.",
        file_exceeds_maximum_size: "The file exceeds the maximum size.",
        reason_select: "Select denounce reason",
        reason_no_selected: "The reason was not selected",
        comment_title: "Add comment",
        comment_description:
            "Here you can add a comment to accompany your denounce",
        comment_warning: "The text must be at least 5 characters.",
        valid_charters: "Only the following characters are allowed: A-Z a-z 0-9 . , ' & \" - _",
    },
    live_search_report_form: {
        new_report: "New report",
        source: "Source",
        option_meli_dump: "Dump",
        option_meli_api: "API",
        search_word: "Search Term",
        nickname_seller: "Seller Nickname",
        listing_state: "Listing status",
        all: "All",
        active: "Active",
        paused: "Paused",
        countries: "Countries",
        no_countries: "There are no selected countries",
        preview: "Apply and search",
        create: "Create report",
        selected_country: "selected country",
        selected_countries: "selected countries",
        clarification: "The report is generated using data updated once per day.",
    },
    denunciated: "reported",
    denunciation: "report",
    download_report_results: "Download Report Results",
    ebay: "eBay",
    edit: "Edit",
    email: "E-mail",
    enter_keyword_for_live_search: "Select your search criteria",
    start_the_search_in: "Start my search in ",
    stored_searches: "Saved searches",
    export_data: {
        reports: {
            all_sellers: "All sellers",
            audits_by: "Audits by",
            avoid_words: "Avoid words",
            blacklisted_sellers: "Blacklisted sellers",
            brand: "Brand",
            city: "City",
            brands: "Brands",
            ok: "Ok",
            accept: "Accept",
            cancel: "Cancel",
            cancel_batch_warning:
                "You're going to loose all your changes. Are you sure?",
            category: "Category",
            choose_another_brand: "Choose another brand",
            choose_brand: "Choose brand",
            condition_all: "All",
            condition_from_blacklisted_sellers: "From Blacklisted Sellers",
            condition_new: "New",
            condition_used: "Used",
            condition_refurbished: "Refurbished",
            "official-store": "Official Store Product",
            languages: {
                es: "Spanish",
                en: "English",
                pt: "Portuguese",
            },
            countries: {
                AA: "Global",
                AR: "Argentina",
                AT: "Austria",
                BE: "Belgium",
                BO: "Bolivia",
                BR: "Brazil",
                CA: "Canada",
                CH: "Switzerland",
                CL: "Chile",
                CO: "Colombia",
                CR: "Costa Rica",
                DE: "Germany",
                DO: "Dominican Republic",
                RD: "Dominican Republic",
                EC: "Ecuador",
                EN: "England",
                ES: "Espana",
                FR: "France",
                GB: "United Kingdom",
                GT: "Guatemala",
                HN: "Honduras",
                IE: "Ireland",
                IT: "Italy",
                MX: "Mexico",
                NI: "Nicaragua",
                NL: "Holland",
                PA: "Panama",
                PE: "Peru",
                PR: "Puerto Rico",
                PT: "Portugal",
                PY: "Paraguay",
                SC: "Scotland",
                SV: "El Salvador",
                US: "USA",
                UY: "Uruguay",
                VE: "Venezuela",
            },
            country: "Country",
            currency: "Currency",
            date_finish: "Date Finish",
            date_start: "Date Start",
            generated_by: "Generated by",
            id: "Id",
            items_sold: "Items sold",
            listing_lnk: "Listing link",
            listing_title: "Listing title",
            listing_type: "Listing type",
            listings: "Listings",
            location: "Location",
            marketplace: "Marketplace",
            marketplaces: "Marketplaces",
            offered_stock: "Offered stock",
            original_currency: "Orig. currency",
            original_price: "Orig. price",
            picture_1: "Picture 1",
            picture_2: "Picture 2",
            picture_3: "Picture 3",
            picture_4: "Picture 4",
            price: "Price",
            price_range: "Price range",
            quantity: "Quantity",
            removed_listings: "Removed Listings",
            report_code: "Claimed infringement",
            report_currency: "Report Currency",
            report_date: "Flagged on",
            report_description: "Report description",
            report_tags: "Report tags",
            reported_listings: "Reported Listings",
            reports: "Reports",
            required_words: "Required words",
            search_by_marketplaces: "Search made in the following Marketplaces",
            search_terms: "Search Terms",
            seller: "Seller",
            seller_username: "Seller Username",
            sellers_type: "Sellers",
            snapshot: "Snapshot",
            sold: "Sold",
            stock: "Stock",
            tag: "Tag",
            take_down_date: "Take down date",
            report_status: "Report Status",
            top_countries: "Top 5 Countries",
            top_countries_by_publications:
                "Top 5 Countries according to number of listings",
            top_reported_sellers: "Top 5 Reported Sellers",
            top_sellers_by_publications:
                "Top 5 Sellers according to number of listings",
            total_value_reported_listings: "Total Value of Reported Listings",
            user: "User",
            value_higher_than: "Higher than",
            value_less_than: "Less than",
            volume_offered: "Volume Offered",
            volume_reported: "Volume reported",
            volume_sold: "Volume sold",
            worksheet_executive_summary: "Executive Summary",
            worksheet_listings: "Listings",
            worksheet_marketplaces: "Marketplaces",
            worksheet_reported_listings: "Reported Listings",
            worksheet_sellers: "Sellers",
            worksheet_sellers_info:
                "* Some Marketplaces don't offer data about Stock quantity and number of Sold Items.",
            worksheet_tags: "Tags",
        },
    },
    exit_create_account: "Are you sure you want to exit?",
    create_auditor: "Now you can create auditor users",
    auditor_user: "Auditor User",
    name: "Name",
    last_name: "Last Name",
    user_email: "Email",
    user: "User",
    add_auditor: "Add auditor",
    error_password_confirm: "Passwords must match",
    new_password_rules:
        "Password must be grater than 8 characters and different to the current one.",
    error_password_length: "Password length must be grater or equals 8",
    wrong_password: "Wrong password or user",
    forgot_password: "Forgot your password?",
    confirmation_code: "Verification code",
    enter_confirmation_code: "Enter the Verification Code",
    sent_to:
        "The verification code was sent via email to $email. If you are not able to find it, please check your Spam folder.",
    did_not_receive: "I did not receive the code",
    yes: "Yes",
    no: "No",
    wrong_confirmation_code: "Wrong information code",
    send_new_code: "Send new code?",
    set_custom_password: "Please set a custom password",
    add_user: "Add auditor",
    create_user: "Create user",
    create_users: "Create users",
    continue_button: "Continue",
    account_data: "Account details",
    account_data_subtitle:
        "With these details you will be able to link all of your Brand Protection Program users and report in several countries all at the same time.",
    default_account: "This will be the username to log in",
    user_already_exist: "You already have an account created with this email.",
    user_not_found: "The user does not exist in the selected country.",
    auditors: "Auditors",
    auditor: "Auditor",
    meli_token_authenticate_error:
        "Wrong username. Log in with your Brand Protection Program account.",
    code_resend: "We have resend you the code to your email",
    account_welcome_message:
        "now create an account in order to use our new reporting tool",
    account_created_title: "Done! You are now registered in the new tool",
    account_created_message:
        "You can now start reporting more easily and efficiently with the new Brand Protection Program tools.",
    create_account_success: "User successfully created",
    main_account_info: "$account, please remember:",
    account_created_reminder:
        "If you usually report on Brand Protection Program through providers that protect your rights and now you created a user to report directly, consider that the answers to your reports will be received by the providers and they may be unaware of your account.",
    account_created_recomendation:
        "Therefore, we recommend that you contact them to coordinate the follow-up.",
    look_what_you_can_do: "Look at everything you can do",
    create_account_error:
        "There was an error while we were creating the user, please try again",
    export_xls: "Export Template",
    "main-page-welcome-msg": "We renew our Brand Protection Program",
    "main-page-title":
        "We create new processes to identify infringing sellers, and sanction them faster",
    "main-page-subtitle": "Besides, we give you the best tools:",
    "main-page-item-1":
        "Find and report easier on different countries at the same time",
    "main-page-item-2": "Create and save your own search criteria",
    "main-page-item-3":
        "Choose on which sellers you want to focus and and analize only its listings",
    "main-page-item-4": "Go to reports with all reported and removed listings",
    "main-page-item-5": "Add and renew your rights easier and faster",
    register_as_auditor:
        "Register as auditor to start reporting and get to know all the benefits.",
    help_message: "Find all you need in the %{copy_help} section.",
    dont_know_how_to_start: "Don't know where to begin?",
    close_help_dialog_error:
        "There was an error while we were closing the dialog, please try again later.",
    more_about_pppi: "More about Brand Protection Program",
    need_help: "Need some help?",
    help: "Help",
    help_href: "/noindex/pppi/support?lang=en",
    know_more_href:
        "https://global-selling.mercadolibre.com/noindex/pppi/landings/bpp",
    register_href:
        "https://www.mercadolibre.com.ar/noindex/pppi/rights/enroll/",
    contact_us: "Contact us",
    buy_and_sell: "Buy and sell from your cellphone!",
    enter_your_email: "Enter your email",
    failed_articles_message:
        "This Livesearch could not be completed successfully, there were %{count} articles that could not be loaded",
    old_password: "Old password",
    new_password: "New password",
    new_password_confirm: "New password confirm",
    password_changed_success: "Your password has been changed successfully",
    password_changed_error:
        "Sorry, we could not be able to change your password, please try again later",
    enter_your_new_password: "Enter your new password",
    password_confirmation: "Password confirmation",
    change_password: "Update password",
    changing_password: "Updating password",
    send_email: "Send",
    sending_email: "sending email",
    sendind_email: "sending",
    filter_profile: {
        attributes: "Attributes",
        brand: 'Brand',
        allBrands: 'All brands',
        model: 'Model',
        allModels: 'All models',
        noOption: 'No options',

        "clarification-p1": "By clicking ",
        "clarification-p2": "Apply and search, ",
        "clarification-p3": "your preferences will be saved automatically.",
        all: "All countries",
        apply_filters: "Apply and search",
        article_condition: "Condition",
        categories: "Categories",
        none_category: "None",
        no_subcategories_for: "There are no subcategories for",
        no_category_selected: "You don't have any selected categories",
        info_categories_language:
            "We’ll show the categories in the language of the country you’re searching in.",
        change: "Change",
        article_new: "New",
        article_used: "Used",
        available_quantity: "Available stock",
        banned_keywords: "Banned keywords",
        copy_of: "Copy of %{name}",
        "country.name": "Country",
        "prices.USD": "Price",
        date_range: "Date range",
        default: "Default",
        extended_data_warning:
            "This will only retrieve articles from sites that provide this kind of data.",
        extended_data_sites_list: "Sites available: %{sites}.",
        fromDate: "Date From",
        fromPrice: "Price from",
        greater_than: "Greater than",
        no_name: "No name",
        portal: "Portal",
        price_range: "Price",
        required_keywords: "Required keywords",
        seller: "Sellers",
        seller_blacklisted: "Blacklisted sellers",
        no_seller_selected: "You don't have any sellers selected",
        none_seller: "None",
        sold_quantity: "Sold stock",
        sort_by: "Sort by",
        select_sort_by: "Select",
        title: "Filter profiles for this Livesearch",
        toPrice: "Price to",
        toDate: "Date To",
        select_one_site: "Select at least one country",
        clean_filter: 'Clear Filters'
    },
    filter: "Edit filters",
    clean_filter: "Clean filters",
    filtered: "Filtered",
    filtered_results: "Filtered results",
    filters_title: "Search Criteria – Refine results",
    forgot_your_password: "Forgot your password?",
    generating_report_results: "Generating Report Results",
    greater_than: "Higher than",
    home_title: "Brand monitoring",
    in_progress: "in process",
    processing: "Processing",
    language: "Language",
    live_search: "Livesearch",
    live_search_all_loaded: "All results shown",
    live_search_fetch_error:
        "We're Sorry but there was an error when trying to fetch the Livesearch. Please try again",
    live_search_create_error:
        "We're Sorry but there was an error when trying to create the Livesearch. Please try again",
    live_search_refresh_error:
        "We're Sorry but there was an error when trying to update the Livesearch. Please try again",
    live_search_delete_error:
        "We're Sorry but there was an error when trying to delete the Livesearch. Please try again",
    live_search_filters: "Search criteria",
    live_search_loading_results: "Loading more results",
    live_search_queue_header: "Livesearch queue – Search in process",
    live_search_recent: "RECENT",
    live_search_refinements_error:
        "There was an error while aplying filters, please try again!",
    live_search_reloading: "Restarting",
    live_search_results: "SEARCH RESULTS",
    live_search_empty: "There are no results yet",
    show_hidden_publications: "View hidden listings",
    hidden_tooltip_text:
        "We've hidden the listings you marked as non-infringing, those you've already reported and those who belongs to whitelist sellers.",
    in_moderation: "Reported",
    validated: "Non-infringing",
    denounced: "Reported",
    multiple_selector: {
        advice:
            "Remember that you cannot use the batch mode to report image copyrights.",
        trusted: "Whitelisted",
        suspicious: "Suspicious",
        tooltip_text:
            "You cannot use this function to report unauthorized use of images.",
        select_all_page: "Select all on page",
        max_selection_reached: "Maximum 50 items selected",
        selection_limit_reached: "You have reached the limit of selected products.",
        selection_limit_tooltip: "You have reached the daily limit of products you can select.",
        selection_limit_info_tooltip: "On this page you can only request the report of a limited number of products, but in general you can select up to 50 products per day.",
        max: "max",
    },
    quick_search: "Quick search",
    quick_search_placeholder: "Search by keywords, EAN or Part Number",
    publication_id: "Listing ID",
    publication_id_placeholder: "MLB-745531777 o MLB745531777",
    publication_id_helper:
        "Find the complete ID in the listing’s URL. Fill it in with or without hyphens.",
    seller_nickname: "Seller name",
    search_label_seller: "Words to look for (optional)",
    search_label_publication: "Quick search",
    url: "URL",
    no_matches: "No listing matches your search",
    no_matches_advice1: "Check the spelling or use more generic terms.",
    no_matches_advice2: "Try deleting one or more of the search terms.",
    no_matches_advice3: "Make sure the seller is still active on our site.",
    no_matches_advice4: "Change filters",
    nothing_here: "Nothing here...",
    you_did_not_do_any_search_yet: "You don't have any saved searches",
    live_search_empty_filtered: "There are no results for the filters applied",
    live_search_status_count_error:
        "There was an error while we were searching article status counts",
    live_search_new_processed_count: "Available new results",
    live_search_processed_count_error:
        "There was an error while we were searching the livesearch processed count, please try again",
    loading: "Loading...",
    loading_publications: "Loading publications...",
    loading_articles: "Loading articles",
    loading_brands: "Loading brands...",
    loading_live_searches: "Loading Livesearches",
    loading_portals: "Loading websites",
    loading_results: "Loading results",
    login: "Login",
    login_welcome_message:
        "Log in with the username and password for the new tool",
    loging_in: "Loging in...",
    recover_password: "Recover password",
    contact: "Contact",
    logout: "Log Out",
    enroll_rights: "Enroll rights",
    new_profile: "New profile",
    change_profile: "Change profile",
    create_profile: "Create",
    select_profile: "Select profile",
    create_profile_success: "You have sucessfully created a new profile",
    change_profile_success: "You have successfully changed your profile",
    create_profile_error:
        "There was an error while we were creating the profile",
    fetch_profiles_error:
        "There was an error while we were searching the available profiles",
    change_profile_error:
        "There was an error while we were changing the profile, please try again later",
    no_profiles: "No profile available",
    create_account: "Create account",
    lower_than: "Lower than",
    other_sales_conditions: "Other selling conditions",
    mercadolibre: "Mercadolibre",
    money_saved: "Money Saved",
    new_live_search: "New Livesearch",
    new_search: "New Search",
    new_product: "New product",
    new_product_up: "New",
    refurbished_product: "Refurbished Product",
    next: "Next",
    no_data: "N/A",
    optional: "optional",
    password: "Password",
    create_user_password: "Password",
    pending: "pending",
    phone: "Phone",
    placeholder_avoided_keywords: "Enter here the words to be excluded",
    placeholder_required_keywords: "Enter here the required words",
    previous: "Previous",
    price: "Price",
    price_range: "Price range",
    prices_larger_than_currency: "Prices higher than",
    prices_smaller_than_currency: "Prices lower than",
    quebarato: "Que Barato",
    refine_search_in_sites: "Refine search criteria",
    remember_me: "Remember me",
    repeat_password: "Repeat password",
    report_label: "Mark as suspicious",
    report_label_plural: "Mark as suspicious",
    edit_report_label: "Save changes",
    report_article_error:
        "We're Sorry but we couldn't send the notice of claimed infringement. Please try again",
    report_article_undo_error:
        "We're Sorry but we couldn't undo that action. Please try again",
    report_code: "Claimed infringement",
    report_code_2: "Claimed infringement",
    report_description_label: "More comments",
    report_description: "Report Description",
    report_description_2: "Report Additional Description",
    report_placeholder:
        "Write down your comments about the listing you’re about to flag (optional).",
    report_to_marketplace: "Report to Site",
    report_status_takedown_submitted: "Takedown Submitted",
    report_status_listing_removed: "Listing Removed",
    report_status_takedown_failed: "Takedown Failed",
    reported_article: "Reported Item",
    reported_to_site: "Reported Site",
    reports: "Reports",
    reports_uppercase: "REPORTS",
    reported_by: "Reported by",
    reputation_excelent: "Excelent",
    reputation_bad: "Bad",
    reputation_good: "Good",
    reputation_regular: "Regular",
    reputation_unknown: "Unknown",
    required_words: "Required words",
    results_per_page: "Results per page",
    screenshoot: "Screenshot at the time of reporting",
    search_of_black_sellers_created:
        "Livesearch with current listings from all Blacklisted Sellers created",
    searches: "Search",
    searches_uppercase: "SEARCHES",
    selected_articles: "Selected Articles",
    seller: "Seller",
    seller_blacklist: "Watch seller",
    black_seller: "Blacklisted seller",
    seller_search_create: "Create livesearch for seller",
    seller_search_created: "Livesearch created",
    seller_white: "Whitelist seller",
    unset_seller_error:
        "We could not update this seller information, please try again later",
    sellers: "Sellers",
    sellers_black: "Blacklisted Sellers",
    sellers_white: "Whitelisted Sellers",
    send_me_reset_password_instructions: "Send me reset password instructions",
    sending_report: "Sending report",
    settings: "Settings",
    profile: "Profile",
    show_current_listing: "Show Current Livesearch",
    enter: "Login",
    entering: "Entering",
    sign_in: "Sign in",
    signing_in: "Signing in",
    sign_up: "Sign up",
    site: "Site",
    site_reputation: "Site Reputation",
    hello: "Hello",
    not_found: "It seems that this page does not exist",
    initial_page: "Go to the main page",
    authorize_sites: "Link countries",
    authorized_site_message:
        "Link all the accounts you use in the Brand Protection Program to report in all countries at once. You will only need to enter the username and password of each country. ",
    authorized_site_title:
        "We noticed you have rights to report in more than one country",
    authorized: "Authorized",
    "new-authorize": "New",
    authorized_country: "Done! You have linked the account for",
    link_other_countries: "Link other countries",
    linked: "Linked",
    link: "Link",
    authorize_site_error:
        "Ooops... there was an error while we were trying to authorize the site, please try again later",
    authorize_site_error_not_pppi:
        "The user with whom you are trying to authenticate does not have a report permission, try to unlog yourself in Mercado Libre and try again with the correct user.",
    incorrect_site_authentication:
        "You have tried to log in with a user that does not belong to the country that you selected. You have to log out in Mercado Libre of that country and try again with a corresponding user.",
    authorize_different_account:
        "You have tried to log in with a user that does not belong to your account.",
    go_to_main_page: "Start reporting",
    start_reporting: "Start reporting",
    sold: "sold",
    sold_quantity: "sold",
    sort_by: "Sort by",
    start_live_search: "Process and Search",
    "dont-repeat-livesearch": "There can not be repeated livesearches",
    status: "Status",
    adding_reported_articles: "Adding Suspicious Listings...",
    add_reported_articles_by_xlsx: "Add Suspicious Listings by Excel",
    submit_all_reported_articles: "Send all denounces",
    submit_selected_reported_articles_s: "Send {10} report",
    submit_selected_reported_articles_p: "Send {10} reports",
    submit_all_reported_articles_tooltip_pending_cn:
        "You can't send reports until you check all your pending counter-notices.",
    submit_all_reported_articles_tooltip_restricted:
        "We restricted your reports while we verify if they match your enrolled rights.",
    submit_all_reported_ready: "Done! We sent your reports",
    submit_one_reported_ready: "Done! We sent your report",
    submit_all_reported_ready_multiple_denounce: "Done! To manage and send your reports, go to the Suspicious listings section.",
    submit_one_reported_ready_multiple_denounce: "Done! To manage and send your reports, go to the Suspicious listings section.",
    submit_multiple_denounce_send_ready: "Done! You have reported the products.",
    filter_text: "Filter and sort",
    filter_text_2: "Filter",
    filter_modal: {
        filter_1: "Sort by",
        filter_2: "Reason for report",
        filter_3: "Country",
        filter_4: "For Status",
        apply: "Apply filters",
        apply_2: "Apply",
        clean: "Clear filters",
        filter_1_text_1: "Most recent reports",
        filter_1_text_2: "Oldest reports",
        all_reasons: "All the report reasons",
    },
    send: "Send",
    delete: "Delete",
    search_text: "Search by No. or title",
    select_all: "Select all",
    selected_notices_s: "Tienes {10} denuncia seleccionada",
    selected_notices_p: "Tienes {10} denuncias seleccionadas",
    select_page: "Select this page",
    unselect_all: "Clear all",
    unselect_page: "Clear this page",
    clean_all_inactive_btn: "Clear inactive",
    clean_one_inactive_btn: "Clear inactive",
    clean_notices: "Delete reports",
    clean_selected: "Delete selected reports",
    filters_applied: "Filters applied",
    clean_all: "Delete all reports",
    clean_inactive: "Delete inactive reports",
    clean_all_inactive_ready: "Done! We deleted your reports.",
    clean_one_inactive_ready: "Done! We deleted your report.",
    submit_report: "Send report",
    submit_report_2: "Request report",
    edit_report: "Edit report",
    submit_reported_articles: "Send notice of claimed infringement",
    create_live_search_current_listings:
        "Create Livesearch with current listings from blacklisted sellers",
    questions_and_answers: "QUESTIONS AND ANSWERS",
    fetch_questions_and_answers_error:
        "There was an error getting the questions and answers.",
    support_form: {
        title: "support",
        subtitle:
            "From here we will help you solve all your questions about the Brand Protection Program.",
        textarea_label: "Send us your question",
        textarea_placeholder: "What can we help you with?",
        send_to: "We’ll reply to",
        submit: "Submit question",
        success_modal_title: "Message received!",
        success_modal_will_respond:
            "We’ll reply to your e-mail within the next 48 hours.",
        success_modal_cx_number: "Your case number is ",
        success_modal_understood: "Understood",
        error_message: "We couldn’t submit your question. Try again later.",
    },
    support: {
        title: "Help section",
        contents: "Help section",
        video: "https://www.youtube.com/embed/n0MyiVMt-Xs",
        "contents-steps": {
            "sug-1-1": "Suggested listings",
            "sug-1-2": "Statistics",
            "sug-1-3": "Weekly development",
            "sug-1-4": "Pin item",
            "1-1": "Making a search",
            "1-2": "How to make a search",
            "1-3": "Search filters",
            "1-4": "Listing details",
            "2-1": "Evaluate a listing",
            "2-2": "Validate a listing as suspicious",
            "3-1": "Batch mode",
            "3-2": "As suspicious",
            "3-3": "As trusted",
            "4-1": "Suspicious listings to report",
            "4-2": "Management of articles to report",
            "8-1": "Catalog listings",
            "8-2": "What is a Catalog listing?",
            "8-3": "How to explore participating sellers",
            "8-4": "Which data the seller defines",
            "8-5": "Who answers the buyer's questions",
            "8-6": "How to report a Catalog listing",
            "5-1": "Evaluate sellers",
            "5-2": "How to evaluate sellers",
            "5-3": "How to see all blacklisted and whitelisted sellers",
            "6-1": "Case management",
            "6-2": "Open cases",
            "7-1": "Enroll new rights",
            "7-2": "How to enroll new rights",
        },
        "answer-steps": {
            "sug-1-1":
                "In this section, you will see the listings we found, based on our detections and on your report history.",
            "sug-1-image": "01_Eng_captura_Suger.png",
            "sug-2-1":
                "This complement aims at making suspicious listings visible and ready to be reported.",
            "sug-2-2a": "The ",
            "sug-2-2b": "'Report' ",
            "sug-2-2c": "button leads straight to ",
            "sug-2-2d": "'Suspicious listings to report'",
            "sug-3-1":
                "Here you will find a brief summary of your accomplished work and will be able to view your progress during the last week.",
            "sug-3-2":
                "The values that also appear refer to the number of items tagged as suspicious and as trusted within the last week. Remember that these values are taken only from the items suggested by Mercado Libre.",
            "sug-3-3":
                "The graph shows the flow of the daily reports for the last week. When you hover over the graph, you will see the value of the specific date selected.",
            "sug-3-4":
                "The percentage on the green tag will be shown if the number of your reports increase in this section and on the red one if it has decreased, compared to the previous week.",
            "sug-2-image": "02_Eng_captura_Suger.png",
            "sug-3-2a": "This function enables you to ",
            "sug-3-2b": "pin elements in the first results ",
            "sug-3-2c":
                "and then activate them or avoid missing them. Also, it enables a quick scan of what we have suggested and to accumulate them and later focus on its analysis with more criteria.",
            "sug-3-image": "03_Eng_captura_Suger.png",
            "1-1p1a": "In this section you can search listings by ",
            "1-1p1b": "country* ",
            "1-1p1c": " using different ",
            "1-1p1d": "search criteria: ",
            "1-1p2t": "- Listing name",
            "1-1p2":
                "Search using keywords related to your brand or enrolled rights.",
            "1-1p3t": "- Listing ID",
            "1-1p3":
                "It is the number that uniquely identifies each listing on Mercado Libre.",
            "1-1p4t": "- Seller name",
            "1-1p4": "It is the seller nickname on Mercado Libre.",
            "1-1p5t": "- Listing URL",
            "1-1p5": "It is the direct link to a listing.",
            "1-1-clarification":
                "* Remember that you can search only in those countries which you have enrolled.",
            "1-1-image": "04_Eng_captura_Suger.png",
            "1-2-1p1a": "Select on the menu on the left ",
            "1-2-1p1b": "Searches.",
            "1-2-2":
                "Select the search criteria to be used and fill in the search field.",
            "1-2-3a": "Mark the country where you want to search for listings. ",
            "1-2-3b": "Argentina ",
            "1-2-3c":
                "is set as default, but you can change the country whenever you want.",
            "1-2-4a": "Start the search by clicking on ",
            "1-2-4b": "Search.",
            "1-3a":
                "Once in the list of listing, you can change the search filters to refine the results. To do so, click on the ",
            "1-3b": "arrow icon ",
            "1-3c":
                "on the top-left-hand corner and a list will appear with all filters available.",
            "1-2-image": "05_Eng_captura_Suger.png",
            "1-3-1-title": "Price",
            "1-3-1-text":
                "Defines the search by minimum and maximum price range of products.",
            "1-3-2-title": "Condition",
            "1-3-2-text": "If it is a new or used product.",
            "1-3-3-title": "Categories",
            "1-3-3-text":
                "It enables filtering according to listing categories on the website.",
            "1-3-4-title": "Blacklisted sellers",
            "1-3-4-text":
                "Applies the search on all sellers marked as blacklisted.",
            "1-3-7a": "After selecting the filters, click on ",
            "1-3-7b": "Apply and search.",
            "1-3-8":
                "* Remember that you can search only in those countries in which you have enrolled.",
            "1-4":
                "On the results screen, click on a product to view its details. Then, you will be able to see the listing information, the seller details and reputation, as well as the product price and pictures.",
            "1-3-image": "06_Eng_captura_Suger.png",
            "2-1": "Validate a listing",
            "2-1-1": "From the list of listing",
            "2-1-2a":
                "Hover the mouse over the listings. Click on SUSPICIOUS and TRUSTED buttons to validate them.",
            "2-1-image": "07_Eng_captura_Suger.png",
            "2-1-2b":
                "If you choose the TRUSTED button, the listings will automatically disappear from the search results. If you choose the SUSPICIOUS button, you can 'flag as suspicious' and add the reason.",
            "2-2-image": "08_Eng_captura_Suger.png",
            "2-2-1": "From the listing details",
            "2-2-1a":
                "From this point, you can indicate with the TRUSTED or SUSPICIOUS button if you think it is violating any of your enrolled rights or not.",
            "2-3-image": "09_Eng_captura_Suger.png",
            "2-2-1b":
                "All the products that you had validated as TRUSTED or SUSPICIOUS will be automatically removed from the next search results.",
            "2-3-1": "Validate a listing as suspicious",
            "2-3-2":
                "If you believe an article is violating one or more of your rights, click on the SUSPICIOUS button.",
            "2-3-3":
                "On the menu on the right, with listing details, you will be able to mark the reason for reporting the listing.",
            "2-3-4": "The reasons are as follows.",
            "2-3-4a": "On the product:",
            "2-3-4a-1": "Counterfeit product",
            "2-3-4a-2": "Copyright violation",
            "2-3-4b": "On the listing:",
            "2-3-4b-1": "Illegal use of trademark",
            "2-3-4b-2": "Unauthorized use of third-party images",
            "2-3-4b-3": "Unauthorized use of personal images",
            "2-4-1": "Once the reason is selected and you click on ",
            "2-4-2": "'Continue' ",
            "2-4-3":
                "you will be able to include a comment. Then, click on 'Flag as suspicious'.",
            "2-4-image": "10_Eng_captura_Suger.png",
            "2-5-1":
                "To send a report about this listing, enter the 'Suspicious listings to report' on the menu on the left.",
            "3-1-1":
                "This complement enables you to quickly flag several listings as ",
            "3-1-2": "'Trusted' or 'Suspicious' ",
            "3-1-3":
                "at a time. Remember that you can flag these listings as suspicious only if they share the same reason for the report.",
            "3-1-image": "11_Eng_captura_Suger.png",
            "3-2-1": "How to flag several listings as 'Suspicious'",
            "3-2-2":
                "Click on the 'Batch mode' button and flag all the listings you want to select as 'suspicious' and you will see that the listings flagged will be highlighted in red.",
            "3-2-3":
                "Press the 'Apply' button to flag them as suspicious and continue the report.",
            "3-2-image": "12_Eng_captura_Suger.png",
            "3-3-1": "How to flag several listings as 'Trusted'",
            "3-3-2":
                "Click on the 'Batch mode' button and flag as 'trusted' all the listings that you want to select and you will see that the listings flagged will be highlighted in green.",
            "3-3-3":
                "Touch on the 'Apply' button, so that they disappear from the search list.",
            "3-3-image": "13_Eng_captura_Suger.png",
            "4-1-1": "Management of articles to report",
            "4-1-2":
                "On the left menu, within in the 'Report suspicious listings' section, you will find all the listings flagged as potential violations, but which have not been reported yet.",
            "4-1-image": "14_Eng_captura_Suger.png",
            "4-2-1": "Confirm report",
            "4-2-2a":
                "If you are sure that you want to report the listing, click on ",
            "4-2-2b": "'Send report'. ",
            "4-2-2c": "To send all reports at once, click on ",
            "4-2-2d": "'Send all reports'.",
            "4-3-1": "Cancel report",
            "4-3-2": "If you want to cancel the report, click on ",
            "4-3-3": "'Dismiss'",
            "4-4-1": "Check details",
            "4-4-2":
                "If you want to check the report details, click on the '+' icon.",
            "4-5-1": "Edit the report reason",
            "4-5-2a":
                "If you want to change the reason for the report, click on the ",
            "4-5-2b": "'Edit'",
            "4-5-2c": "button and follow the instructions to add a new reason.",
            "5-1-1":
                "In this section, you can see all sellers that you blacklisted and those that you marked as trusted.",
            "5-1-image": "15_Eng_captura_Suger.png",
            "5-2-1": "How to evaluate sellers",
            "5-2-2":
                "When viewing the listing details, you will see three buttons that enable the evaluation of sellers.",
            "5-3-1": "Blacklisted seller",
            "5-3-2":
                "The seller will receive a black flag. As you identify a seller as blacklisted, his products will be highlighted in your searches, in order to be easily recognized.",
            "5-2-image": "16_Eng_captura_Suger.png",
            "5-4-1": "Trusted seller",
            "5-4-2":
                "When you flag the seller as trusted, he will be automatically included in the list of trusted sellers, and his listing will be removed from the search results.",
            "5-5-1": "Creating the seller livesearch",
            "5-5-2a": "Create a ",
            "5-5-2b": "'Saved search' ",
            "5-5-2c":
                "of the product category and seller, in order to be checked later. You can access it on Search, on the menu on the left.",
            "5-6-1": "Blacklisted sellers",
            "5-6-2":
                "On the listing details, click on the search icon, next to the seller's name. Thus, you will see all sellers that you flagged as blacklisted in your searches.",
            "5-6-3a": "You can access this list on the menu on the left in ",
            "5-6-3b": "Sellers > Blacklisted sellers.",
            "5-3-image": "17_Eng_captura_Suger.png",
            "5-6-4":
                "The table shows the country where each blacklisted seller operates, as well as their Mercado Libre user name, the number of reports received and the quantity of products in his sales list.",
            "5-7-1": "How to check all the articles from blacklisted sellers",
            "5-7-2a": "First, click on ",
            "5-7-2b": "'Create a new livesearch'",
            "5-7-2c":
                "in the table. This search will be saved on the 'Search' section.",
            "5-4-image": "18_Eng_captura_Suger.png",
            "5-8-1": "Whitelisted sellers",
            "5-8-2":
                "Here you will see all the sellers that you flagged as whitelisted in your searches.",
            "5-8-3a": "You can access on the menu on the left, in ",
            "5-8-3b": "Sellers > Whitelisted sellers.",
            "5-5-image": "19_Eng_captura_Suger.png",
            "5-8-4":
                "The table shows the country where the seller operates, his Mercado Libre user name and the number of products in his sales list.",
            "5-9-1": "How to check all the articles from blacklisted sellers",
            "5-9-2a": "First, click on ",
            "5-9-2b": "'Create a new livesearch' ",
            "5-9-2c":
                "in the table. This search will be saved on the 'Searches' section.",
            "6-1-1":
                "Here you can track the status of your reports and reply the sellers to decide whether you want to confirm or cancel your report.",
            "6-1-image": "20_Eng_captura_Suger.png",
            "6-2-1":
                "It shows a table with all open cases. Click on any report to view the details.",
            "6-2-2-title": "Counter-notice",
            "6-2-2-text":
                "It shows the date when the seller sent the counter-notice to your report, jointly with the comments and attached files.",
            "6-2-3-title": "Report",
            "6-2-3-text":
                "It shows the date when the listing was reported, the name of the auditor and the unique code of the report.",
            "6-2-4-title": "Listing",
            "6-2-4-text":
                "It is a screenshot of the listing just as seen on the day when the report was made.",
            "6-2-5-title": "Seller information",
            "6-2-5-text":
                "Here you will see the information of the seller who listed the product that you reported, such as his reputation on Mercado Libre, number of reports made, counter-notices sent and accepted.",
            "6-2-6":
                "If you think the counter-notice is sufficient and wish to take your report down, select the thumbs-up icon, but if you think that the counter-notice is not sufficient, select the thumbs-down icon.",
            "6-3-1": "Reply to the seller",
            "6-3-2a": "In this part, you will have the chance to ",
            "6-3-2b": "'Confirm or refuse the report' ",
            "6-3-2c": "and leave a comment to send to the seller.",
            "6-4-1":
                "If you decide to refuse the report, you must select the reason.",
            "6-2-image": "21_Eng_captura_Suger.png",
            "7-2-1":
                "If you need to add new rights to make more and better reports, please ",
            "7-2-1b": "click here.",
            "7-2-2-title": "On the screen to enroll rights",
            "7-2-2-text":
                "Select the checkbox off the right you want to enroll. If you need to enroll more than one, you can select multiple options.",
            "7-2-3":
                "For each type of right that you select, a white box will appear at the bottom of the screen. For each case, please attach the required documentation.",
            "7-2-4": "When finished, click on the ",
            "7-2-5": "Send documentation.",
            "7-2-6":
                "Done! Our representatives will analyze your documentation and notify you by email about your request status.",
            "8-1-1": "Catalog listings",
            "8-2-1": "What is a Catalog listing?",
            "8-2-2":
                "This is a 'product page' that groups, under a single content, several listings offered by different sellers.",
            "8-2-3":
                "Sellers' listings compete to be the first option that buyers see. Whoever offers the best selling conditions and experience will be the 'Winner'. Competition is based, among other things, on price, the seller's reputation and the selling conditions offered.",
            "8-3-1": "How to explore participating sellers",
            "8-3-2":
                "Note that the 'product pages' have variations. For example, for a cell phone, different features and colors available are shown. For each combination of variations, there may be a different winner.",
            "8-3-3":
                "When you see a Catalog listing in the reporting tool, you can go to the listing detail to know the participating sellers for each variation.",
            "8-3-image": "22_Eng_captura_Suger.png",
            "8-4-1": "Which data the seller defines",
            "8-4-2":
                "The seller configures the specific conditions of the listing participating in the 'Catalog'. This includes price, stock, warranty and shipping method.",
            "8-5-image": "23_Eng_captura_Suger.png",
            "8-5-1": "Who answers the buyer's questions",
            "8-5-2":
                "In a Catalog listing, the answers to buyers' questions are given by the winning seller of the moment.",
            "8-5-3":
                "In the 'Participating sellers' column you can see each seller's answer by simply selecting it.",
            "8-6-1": "Learn more about Catalog listings",
            "8-7-1": "How to report a Catalog listing",
            "8-7-1-a": "To report the listing photos,",
            "8-7-1-b":
                "select the 'Mark as suspicious' option in the section that displays the product details",
            "8-7-image": "24_Eng_captura_Suger.png",
            "8-7-2-a": "To report a seller's listing,",
            "8-7-2-b":
                "explore the 'Participating sellers' column and click on the 'Mark as suspicious' button.",
            "8-7-2-image": "25_Eng_captura_Suger.png",
            "8-8-1": "The listings you mark as suspicious will appear in the ",
            "8-8-1-a": "'Report suspicious listings'",
            "8-8-1-b": "section and you may manage them as usual.",
        },
        "question-livesearch": "What is a Livesearch?",
        "answer-livesearch":
            "Livesearches are searches of listings from one or more keywords. You can do your searches by country or for several countries at the same time, as long as you are authorized to report in more than one country. It is important that the words you use are related to the brand you audit in order for you to obtain more accurate results.",
        steps: {
            "1-1": "On the left menu, select",
            "1-2": "Search",
            "2-1": "Enter the keywords and click on",
            "2-2": "Search",
            "3-1": "Indicate the countries you wish and click on",
            "3-2": "Perform Search",
            "4-1":
                "When you start the livesearch process, you will see the number of listings that exist for the keywords you entered. If you click on the keyword(s) listed in the livesearch, you can start reviewing the listings. You can start auditing even if the search is still in process.",
        },
        "question-grid": "Results Grid",
        "answer-grid":
            "In the result gridview you will find all the listings that correspond to the keywords you used in your livesearch.",
        "question-filter-liversearch": "Livesearch Filters",
        "answer-filter-liversearch1":
            "Once you get the results, you can adjust the search and make it much more accurate using filters. You may use them one by one or combine them as you prefer.",
        "answer-filter-liversearch2":
            "You can concentrate your search on one product line of your brand or filter it by the listing date, price, stock, etc. In the same way, you can exclude words from the results.",
        "question-publication": "Listing Detail View",
        "answer-publication":
            "To access the detailed view, you must click on the listing in the results grid. In the detail view you will get more information about the product being offered, its photos, seller information, current stock and sales analysis.",
        "question-publication-valid": "Thumb up",
        "answer-publication-valid":
            "If you see that a listing is not committing any infringement to your brand, You may indicate that the listing is valid with the thumb up. This way, in future searches, that listing will not appear again in the results.",
        "question-publication-invalid": "Thumb down",
        "answer-publication-invalid1":
            "If you see that a listing is committing one or more intellectual property infractions, you must mark it with your thumb down. Then a box will open in which you can add more details regarding the infraction(s) you detected.",
        "answer-publication-invalid2": "Tags",
        "answer-publication-invalid2-1":
            "The tags are reference labels you can use later to issue reports. These labels or descriptions are for internal use only, and do not appear in the formal notice.",
        "answer-publication-invalid3": "Claimed infringement",
        "answer-publication-invalid3-1":
            "It is the code associated with the reason for your complaint. This is related to the rights that you adhered to the Brand Protection Program to report in Mercado Libre.",
        "answer-publication-invalid4": "Details",
        "answer-publication-invalid4-1":
            "You can add details of the reason for the complaint you are about to make. This will be helpful in case a team member needs more information before excluding a listing.",
        "answer-publication-invalid5": "Reporting",
        "answer-publication-invalid5-1":
            "Once you click on Report, the complaint will not be processed and sent to the Brand Protection Program review team, but will rather be sent to Products to report, with the other complaints you have made. Therefore, if you identify that a complaint was poorly made, you will be able to exclude it.",
        "answer-publication-invalid6": "Products to report",
        "answer-publication-invalid6-1":
            "This is where all the listings you marked with the thumb down will be, and where you will report them all. Therefore, it is advisable to review all the details you entered before in order to be certain of the infractions. If you want, you can also visit the listing in Mercado Libre by clicking on the button.",
        "answer-publication-invalid6-2":
            "By clicking on (+), you will see all the report details.",
        "answer-publication-invalid6-3":
            "If you find that a listing that is not in violation, you may select Remove from the list and the complaint will not be made.",
        "answer-publication-invalid6-4":
            "Once you are certain you want to send all the complaints, you can send them individually or massively by selecting Send all reports.",
        "question-whitelistsellers": "Whitelist Sellers",
        "answer-whitelistsellers1":
            "You can identify sellers as reliable (eg. Official Stores, distributors, etc.) so that their listings no longer show up in your livesearch and you do not waste time auditing and analysing them.",
        "answer-whitelistsellers2":
            "To identify the seller, you must open the detail view and click on ",
        "answer-whitelistsellers3": " Whitelist Seller.",
        "question-blacklistsellers": "Blacklist Sellers",
        "answer-blacklistsellers1":
            "If you believe it is necessary to track some sellers and all their listings, you must select Observe seller.",
        "answer-blacklistsellers2":
            "All listings from this seller will be marked with a black flag. You can also filter the results to only view listings from blacklist sellers.",
        "answer-blacklistsellers3-1":
            "You can view the activity of listings and complaints of these sellers in the menu on the left, in the section ",
        "answer-blacklistsellers3-2": "Sellers > Blacklist sellers",
        "question-livesearch-sellers": "Livesearches of Sellers",
        "answer-livesearch-sellers-1":
            "From the detailed view, in the Blacklist Sellers or Whitelist Sellers section, you can create a Livesearch to observe all listings from these sellers.",
        "answer-livesearch-sellers-2":
            "When you identify at least one listing that infringes your brand's rights, it is advisable to analyze all listings from the seller in order to identify if there are more that could affect your brand.",
        "question-post-denunciation": "Post-report Follow-up",
        "answer-post-denunciation1-1":
            "You can generate reports of your activity and export it as an Excel file. You can track all the audit work.",
        "answer-post-denunciation1-2":
            "You will be able to view all the reported listings that were excluded. You can also view a reference photo of the listings when making a complaint.",
        "question-counter-notice": "Counter Notice",
        "answer-counter-notice1":
            "If a seller makes a counter notice to a complaint, you will receive it in the email you entered as your contact email when registering your Brand Protection Program rights. This email corresponds to the one associated to the Brand Protection Program reporting accounts in each country.",
        "answer-counter-notice2":
            "Remember that this email is different from the one you used to register as an auditor to report on this platform.",
        disclaimer:
            "*The images are shown as examples to explain the use of the tool.",
        "question-support": "SUPPORT",
        "see-more": "Questions? We can help.",
        "goto-support": "Go to Support",
    },
    black_sellers: {
        ID: "ID",
        title: "Latest Sellers Listings",
        placeholder_sites: "Select Seller",
        table_th_site: "SITE",
        table_th_country: "COUNTRY",
        table_th_sellers: "SELLER",
        table_th_reports: "REPORTS RECEIVED",
        table_th_actions: "ACTIONS",
        table_th_current_listings: "ACTIVE LISTINGS",
        empty_sellers_message: "There are no Blacklisted Sellers availables.",
        button_create_current_listings: "Create Livesearch with current listings",
        button_delete_current_listings: "Dismiss",
        confirm_delete_client_black_seller:
            "Are you sure that you want to remove this seller from the blacklist?",
        black_list_seller_deleted: "Trustable seller deleted",
        black_list_seller_delete_error:
            "There was en error while we were trying to delete this trustable seller, please try again later",
        fetch_black_list_seller_error:
            "Sorry, there was an error in the search for sellers",
    },
    case_management: {
        cases: {
            pending_title: "Counter-notice to submit",
            pending_table_explanation:
                "The following sellers have responded your complaint with a counter-notice",
            search: "Search",
            table_th_auditor: "Auditor",
            table_th_country: "Country",
            table_th_id: "ID",
            table_th_article: "Listing",
            table_th_sellers: "Seller",
            table_th_status: "Status",
            table_th_denounce: "Flagged on",
            table_th_denounce_2: "Flagged on:",
            table_th_denounce_sent: "Report Date",
            table_th_counter_notice: "Counter notice",
            table_th_response_limit: "Deadline",
            empty_cases_message: "No results found",
            fetch_pending_cases_list_error:
                "We are sorry, there was an error while processing your search.",
            denounced_date: "Reported: ",
            updated_date: "Updated: ",
            canceled_date: "Canceled: ",
            dates: "View dates",
        },
        case_description: {
            denounced_seller: "Reported seller",
            seller_response: "This is what they wrote",
            seller_empty_response: "The seller did not leave comments",
            photos_current: "These are the current images of the listing",
            photos_modified_new: "NEW",
            photos_denounced: "These are the images you reported",
            fetch_description_denounces_error:
                "Lo sentimos, hubo un error al buscar los datos.",
            no_data_found: "No data found",
            "counter-notice_tab": "Seller counter-notice",
            "counter-notice": {
                counter_notice_attached_file: "Attached file",
            },
            denounce_tab: "Report",
            denounce: {
                denounce_date: "REPORT DATE",
                auditor: "AUDITOR",
                code: "CLAIMED INFRINGEMENT",
                additional_description: "AUDITOR NOTES",
            },
            publication_tab: "Listing",
            publication: {
                site: "Mercado Libre",
                price: "PRICE",
                product_sold_in_this_publication: "SOLD ITEMS",
                description: "DESCRIPTION",
                images: "photos",
                image: "photo",
            },
            "seller-data_tab": "Seller Information",
            seller_data: {
                create_seller_LS: "Create LiveSearch for this Seller",
                black_seller: "Blacklist Seller",
                portal_reputation: "Reputation",
                sold_quantity_products: "Items sold",
                denonces_sent_to_this_seller: "Reports",
                counter_notice_received: "Counter notices sent",
                counter_notice_accepted: "Counter notices accepted",
                denounces_table_article: "Listing",
                denounces_table_denounce: "Reported",
                denounces_table_status: "Status",
                denounces_counter_notice: "Seller Response",
                fetch_counter_notices_error:
                    "There was an error getting the seller's complaints",
            },
        },
        documentation_approved: {
            sending_response: "We’re sending your response to the seller.",
            response_placeholder: "I reviewed the counter-notice and decided to:",
            reject_option_member_placeholder: "I’ll confirm it because:",
            approved_case_title: "Respond to the seller",
            approved_case_title_sent: "Response",
            confirm: "Confirm my report",
            retract: "Retract my report",
            confirm_helper_text: "Select this reply to finalize the listing.",
            retract_helper_text: "Select this reply to reactivate the listing.",
            send_response: "Send reply",
            reject_option_label: "Reason for your decision",
            description_label: "Additional comments",
            no_description: "Without description",
            report_placeholder:
                "Explain to the seller why you’ve made this decision.",
            respond_counter_notice_success_confirm: "The listing was deleted.",
            respond_counter_notice_success_retract: "The listing was reactivated.",
            respond_counter_notice_success:
                "Done! We have already sent your reply to the seller.",
            respond_counter_notice_error:
                "We are sorry, something went wrong. Try again or contact support.",
            respond_counter_notice_rejected_by_abuse:
                "The justification does not detail an infringement, so we reactivated the listing.",
            closed_title: "You’ve already replied to this seller",
            responded: "This is what you decided",
            responded_at: "You replied on",
        },
        publication_status: {
            active: "Active",
            closed: "Finished",
            inactive: "Inactive",
            paused: "Paused",
            under_review: "Under review",
        },
        denounce_status: {
            waiting: "Awaiting response",
            pending: "Responded",
            accepted: "Reactivated listing",
            not_approved: "Ended listing",
            not_presented: "Response not submitted",
            not_respond: "Expired",
            rollback: "Retracted",
            discard_due_restriction: "Discarded",
            pending_moderation: "Pending",
            rejected: "Rejected",
            acuerdo_closed: "Ended listing",
            duplicated_denounce: "N/A",
            discarded: "Discarded",
            rejected_modified: "Edited listing",
            revision: "Report under review",
        },
        denounce_status_V3: {
            approved: "Approved",
            in_progress: "Ongoing",
            pending: "Pending response",
            rejected: "Rejected",
            rollback: "Withdrawn",
            discarded: "Discarded",
            waiting: "Awaiting response",
            not_respond: "Report without member response",
            rejected_modified: "Rejected due to modification",
            dismissed: "Report dismissed",
            listing_reactivated: "Listing reactivated",
        },
        pending_denounce_widget: {
            title: "Reports pending counter-notice.",
            subtitle: "Please review the seller counter-notice.",
        },
        status_pill: {
            expire_days: "Expires in {} days",
            expire_day: "Expires in {} day",
            expire_hours: "Expires in {} hours",
        },
    },
    welcome_page: {
        title: "Welcome!",
        subtitle:
            "You are one step away from using the new Mercado Libre reporting tool",
        no_auditor_boton: "I want to register",
        enter_now_to_denounce: "I am already registered",
    },
    welcome_register_page: {
        title: "Welcome to the Brand Protection Program reporting tool",
        subtitle:
            "If you’re already registered in the program, log in with any of your Brand Protection Program usernames. If you don’t have an account yet, register now.",
        subtitle2: "Enter the email registered in the Brand Protection Program",
        email: "Email",
        singin_button: "Login",
        continue_button: "Continue",
        no_account_button: "Register",
        know_more: "Learn more about the program",
    },
    error_no_bpp: {
        title: "We were unable to log in",
        subtitlePart1: "Please log in again and ",
        subtitlePart2: "make sure you use your BPP credentials.",
        btn: "Log in again",
    },
    reported_articles: {
        send: "Send",
        delete: "Delete",
        alerts: {
            cannot_submit_title: "You can’t submit reports",
            cannot_submit_subtitle:
                "We found abusive behaviour in your rejected counter-notices, so we’ve temporarily disabled your reporting capacity.",
        },
        filters: {
            placeholder_title: "Title",
            placeholder_site: "Select Site",
            placeholder_seller: "Select Seller",
            placeholder_term: "Search Listing",
            placeholder_complaint: "Select Status",
            placeholder_reference_id: "ID",
            placeholder_price_from: "Price from (USD)",
            placeholder_price_to: "Price to (USD)",
            placeholder_date_from: "FROM",
            placeholder_date_to: "TO",
            option_selecet_complaint_status_with_error: "Retry send",
            option_selecet_complaint_status_without_error: "Not send",
        },
        articles_reported: {
            title: "History of reports",
            description:
                "Review the status of your reports, and be sure to respond to the ones that are pending",
            search: "Search by ID, or seller name",
            filter: "Filter and sort",
            table_th_seller: "Seller",
            table_th_denounce: "Reported listing",
            table_th_reason: "Reason for the report",
            table_th_status: "Status",
            placeholder_sites: "SELECT SITE",
            table_th_id: "ID",
            table_th_site: "SITE",
            table_th_country: "COUNTRY",
            table_th_article: "LISTING",
            table_th_auditor: "AUDITOR",
            table_th_price: "PRICE",
            table_th_reported: "REPORTED",
            table_th_notice_status: "STATUS",
            table_th_notice_update: "LAST UPDATED",
            table_th_down: "TAKEDOWN",
            reported_at: "REPORT DATE",
            button_clear_filters: "Clear Filter",
            button_submit_filters: "Search",
            empty_reported_articles_message:
                "There are no reported articles availables.",
        },
        denounce_status_tooltip: {
            WAITING_DOCUMENTATION:
                "The seller hasn’t responded to your report yet.",
            DOCUMENTATION_PRESENTED:
                "The seller has already responded to your report.",
            DOCUMENTATION_APPROVED: "You've decided to reactivate this listing.",
            DOCUMENTATION_NOT_APPROVED: "You've decided to finalize this listing.",
            DOCUMENTATION_NOT_PRESENTED:
                "We finalized this listing because the seller didn't respond within the deadline.",
            MEMBER_NOT_RESPOND:
                "You didn't reply to the seller on time and your report has expired.",
            ROLLBACK:
                "You decided to reactivate the seller’s listing as the report was retracted.",
            DISCARDED_DUE_RESTRICTION:
                "The seller was banned from the site, therefore you don't need to review their counter-notice.",
            ACUERDO_CLOSED: "We have finalized this listing.",
            DUPLICATED_DENOUNCE: "N/A",
            REJECTED: "Your report was rejected.",
            REJECTED_BY_ABUSE: "Your justification did not detail an intellectual property infringement. The listing was reactivated.",
            REJECTED_BY_ABUSE_COUNTER_NOTICE: "Your report was rejected.",
            DISCARDED: "The listing was excluded.",
            PENDING_MODERATION: "Your report is still pending.",
            CREATED: "Your report is still pending.",
            CROSS_DENOUNCE_CLOSED: "Your report was rejected.",
            REJECTED_MODIFIED:
                "Your report couldn’t be processed because the listing was modified after your complaint was made.",
        },
        denounce_status_tooltipV3: {
            ACUERDO_CLOSED: "The reported listing was removed.",
            DOCUMENTATION_NOT_APPROVED:
                "The seller documentation was not approved. The reported listing was removed.",
            DOCUMENTATION_NOT_PRESENTED:
                "Your report was approved because the seller did not present the documentation.",
            CREATED: "Your report is pending to be processed.",
            PENDING_MODERATION: "Your report is pending to be processed.",
            WAITING_DOCUMENTATION: "The seller has yet to submit counter-notice.",
            WAITING_FOR_PATCH_PDP:
                "We are analyzing your report. If necessary, we will make the corresponding adjustments.",
            DOCUMENTATION_PRESENTED:
                "The seller is waiting for your response. If you do not submit a counter-notice, the report will be cancelled",
            DUPLICATED_DENOUNCE:
                "Your report cannot be processed because it is duplicated.",
            MEMBER_NOT_RESPOND:
                "Your report was rejected because you did not respond to the seller in the established deadline.",
            REJECTED:
                "Your report was rejected because it does not comply with the mandatory requirements.",
            REJECTED_BY_ABUSE: "Your justification did not detail an intellectual property infringement. The listing was reactivated.",
            REJECTED_BY_ABUSE_COUNTER_NOTICE: "Your justification did not detail an intellectual property infringement. The listing was reactivated.",
            REJECTED_BY_RESTRICTION:
                "You reached the limit of daily reports. Please check your account efficiency.",
            DOCUMENTATION_APPROVED:
                "The seller's documentation was approved and your report was withdrawn.",
            ROLLBACK:
                "You withdrew the report. The reported listing will be reinstated.",
            DISCARDED:
                "Your report cannot be processed because the listing is no longer available.",
            DISCARDED_DUE_RESTRICTION:
                "Your report cannot be processed because the seller is shut down.",
            REJECTED_MODIFIED:
                "Your report was removed because the listing was edited.",
            REJECTED_PDP_CATALOG:
                "Your report was removed because the images you reported were obtained from a private image bank.",
        },
        info_cn_message: {
            title: "Now your reports are resolved in less time",
            description: "The time frame to resolve reports is now 6 days: three days for the seller to respond to your report and three days for you to review their response.",
            description_2: "We count every day from Monday to Saturday, including holidays, ",
            description_2Strong: " but Sundays don't count.",
            description_3: " For example: if you file a report on a Friday at 10 am, the seller will have until Tuesday at the same time to respond.",
            description_4: "With this change you manage your reports faster and protect your brand more efficiently.",
            button: "I understand",
        },
        index: {
            title: "Report suspicious listings",
            table_th_site: "SITE",
            table_th_country: "COUNTRY",
            table_th_article: "LISTING",
            table_th_auditor: "AUDITOR",
            table_th_price: "PRICE",
            table_th_antiquity: "FLAGGED ON",
            table_th_more: "MORE",
            table_of_text: "of",
            table_next_text: "Next",
            table_rows_text: "rows",
            table_page_text: "Page",
            table_previous_text: "Previous",
            table_loading_text: "Loading...",
            table_no_data_text: "No rows found",
            empty_reports_message: "No listings to report.",
            removed_clarification: "Removed",
            removed_clarification_tooltip:
                "You can't report this listing because it’s already been removed from the site.",
            button_remove: "Delete",
            removed: "Removed",
            removed_v2: "Listing inactive.",
            button_send_all_complaints: "SEND ALL NOTICES OF CLAIMED INFRINGEMENT",
            button_send_complaint: "Send notices",
            confirm_reported_article_undo: "Dismiss this listing?",
            confirm_reported_article_undo_subtitle:
                "If you do this, you won't see $title any longer in your list of suspicious listings.",
            confirm_reported_article_undo_btn_label: "Dismiss listing",
            confirm_send_all_complaints: "Confirm sending all complaints?",
            button_edit_complaint: "Edit",
            button_retry_complaint: "Retry notice",
            complaint_sent: "Report sent",
            send_complaint:
                "Thank you for send your complaint. We will proced to evaluate it within the next 72 hours",
            send_all_complaints:
                "Thank you for send your complaints. We will proced to evaluate them within the next 72 hours",
            error_send_all_complaints: "There was an error sending all complaints.",
            error_send_complaint: "There was an error sending the complaint.",
            error_send_complaint_already: "The listing was already noticed.",
            error_getting_article_data: "There was an error getting the data",
            failed_not_exits_or_not_published:
                "The article does not exist or it is not published.",
            days: {
                one: "%{count} day",
                other: "%{count} days",
            },
        },
        edit: {
            seller: "Seller",
            tags: "Tags",
            complaint_code: "Claimed infringement",
            placeholder_complaint_description:
                "Write down your comments about the listing you’re about to flag (optional).",
            label_add_tag: "add tag",
            cancel_complaint_edition: "Cancel",
            edit_complaint_edition: "Edit",
        },
        table: {
            th1: "Suspicious listing",
            th2: "Price",
            th3: "Seller",
            th4: "Reason for the report",
        },
    },
    noticed_articles: {
        filter: "Filter",
        filters: {
            all: "All statuses",
            placeholder_id: "ID",
            placeholder_title: "Title",
            placeholder_price_from: "Price from",
            placeholder_price_to: "Price to",
            placeholder_date_from: "Date from",
            placeholder_date_to: "Date to",
            placeholder_country: "Country",
            placeholder_seller: "Seller",
            report_created: "Report generated",
            report_created_error: "There was an error trying to create the report",
            report_no_articles_found:
                "No articles were found to generate the report",
            title_required: "Title is required",
            date_error: "Date from, can not be greater than date to",
            price_error: "Price from, can not be greater than price to",
        },
        // filter: "Filter",
    },
    client_white_sellers: {
        index: {
            ID: "ID",
            title: "Whitelisted Sellers",
            empty_sellers_message: "There are no Whitelisted Sellers availables.",
            table_th_site: "SITE",
            table_th_country: "COUNTRY",
            table_th_seller_name: "SELLER",
            table_th_seller_current_listing: "ACTIVE LISTINGS",
            table_th_actions: "ACTIONS",
            delete_client_white_seller: "Remove",
            confirm_delete_client_white_seller:
                "Are you sure that you want to remove this seller from the Whitelist?",
            white_list_seller_deleted: "Trustable seller deleted",
            white_list_seller_delete_error:
                "Opps... there was en error while we were trying to delete this trustable seller, please try again later",
            fetch_white_list_seller_error:
                "Sorry, there was an error in the search for sellers",
        },
    },
    white_and_black_sellers: {
        filters: {
            ID: "ID",
            country: "Country",
        },
    },
    notice_reports: {
        index: {
            title: "Reports",
            table_th_date: "Date",
            table_th_name: "Report name",
            table_th_download: "Download",
            fetch_reports_error:
                "Opps... There was an error while we were fetching the reports, please try again later",
            click_here_to_download: "Click here to download",
            confirm_delete_report:
                "Are you sure you want to delete this report? this action can not be undone",
            delete_report_error:
                "There was an error while we were trying to delete the report",
            processing_report: "Processing report",
            generate_error: "There was an error in generating this report",
            emply_error: "Sorry, there are no reports with the selected filters",
        },
        create: {
            title: "New custom report",
            create_report: "Create Report",
            placeholder_title: "Title",
            placeholder_date_from: "Date from",
            placeholder_date_to: "Date to",
            placeholder_currency: "currency",
            placeholder_origin: "Audited by",
            placeholder_language: "language",
        },
    },
    livesearch_reports: {
        index: {
            title: "Reports",
            table_th_date: "Date",
            table_th_name: "Report name",
            table_th_download: "Download",
            fetch_reports_error:
                "Opps... There was an error while we were fetching the reports, please try again later",
            click_here_to_download: "Click here to download",
            confirm_delete_report:
                "Are you sure you want to delete this report? this action can not be undone",
            delete_report_error:
                "There was an error while we were trying to delete the report",
            processing_report: "Processing report",
            generate_error: "There was an error in generating this report",
        },
    },
    sites_authorization: {
        from_account: {
            do_it_later: "Link Later",
            finish_and_do_it_later: "Finish and link later ",
        },
        from_search: {
            back_to_search: "Back to search",
        },
        default: {
            start_reporting: "Start reporting",
        },
    },
    redirect_flow_info: {
        title: "Welcome to our brand-new reporting tool",
        subtitle:
            "Reporting infractions and replying to counter-notices is much faster. Take a look at everything you can do:",
        bullet1: "Identify suspicious sellers even quicker",
        bullet2: "Create your own search filters",
        bullet3: "Follow the status of your reports, all in one place",
    },
    tags_title: "Tags",
    label_add_tag: "Add tag",
    total: "Total",
    undo: "Undo",
    unknown_seller: "Unknown Seller",
    unlist_seller_from_black_list_confirmation:
        "Are you sure that you want to remove this seller from the Blacklist?",
    unlist_seller_from_white_list_confirmation:
        "Are you sure that you want to remove this seller from the Whitelist?",
    used_product: "Used product",
    validity: "Validity",
    view_in_site: "View in site",
    initial_question: "Q",
    initial_answer: "A",
    seller_information: "Seller Information",
    description_product: "Descripion",
    question_answer: "Question and Answer",
    welcome: "Welcome",
    go_back: "Go back",
    edit_reported_article_success: "The report to the publication was updated.",
    edit_reported_article_error:
        "We're sorry, we had an error updating the report.",
    done_article_reported:
        "Done! In order to manage and send your reports, check out the",
    done_articles_reported:
        "Done! In order to manage and send your reports, check out the",
    done_variant_reported: "Done! You selected {x} variation. To manage and send your reports, go to ",
    done_variants_reported: "Done! You selected {x} variations . To manage and send your reports, go to ",
    go_to_reported_articles: "Suspicious listings.",
    we_will_send_this_listing_to: "We’ll send this listing to",
    we_will_send_these_listing_to: "We’ll send these listings to",
    got_it: "GOT IT",
    ls_reported_articles_link: "Go to Suspicious listings",
    process_and_clean_results: "Process search",
    live_searches: "Livesearches",
    unable_to_create_live_search:
        "Unable to create Livesearch. Please, try again.",
    server_error: "We're sorry, we've had a server error try again",
    fetch_currency_error:
        "We are sorry, we have had an error in the response of the currency exchange",
    remove_article_error: "We're sorry, we had an error removing the article",
    remove_article_success: "Listing dismissed.",
    fetch_seller_error: "We're sorry, we had an error in the seller's search",
    dashboard: "Dashboard",
    sellers_inactive: "Inactive Sellers",
    tags: "Tags",
    search: "Search",
    enter_your_email_below_to_reset_your_password:
        "Enter your e-mail address below to reset your password",
    error_generating_custom_report: "Failed to generate custom report.",
    without_results: "Without results!",
    refresh: "Refresh",
    try_again: "Try again",
    seller_live_search_created: "Livesearch created",
    create_seller_live_search: "Create Livesearch with current listings",
    error_reporting_seller: "Error reporting seller. Please, try again!",
    error_user_without_report_profile: "The Report Profile does not exist.",
    success_send_all_complaints: "All reports were sent.",
    updated_reported_article_to_ok: "Update reported article status to OK.",
    reported_article_not_found: "Reported article not found.",
    reported_article_already_reported: "Too late, article already reported.",
    update_reported_article_complaint_success: "The report was updated.",
    update_reported_article_complaint_error:
        "We're Sorry but we couldn't update the report. Please try again.",
    complaint_reason: "Claimed infringement",
    complaint_error: "Complaint Error",
    complaint_description: "Report Additional Description",
    invalid_keyword_for_new_live_search:
        "You must enter a keyword to generate a new LiveSearch",
    modal_title: "Loading...",
    error_getting_snapshot: "Could not get snapshot for reported article.",
    response_errors: {
        client_error: "Client error",
        server_error: "Server error",
    },
    enroll_rights_cta_tooltip_header:
        "Keep in mind that you’ll need to log in again with your username in order to enroll new rights.",
    enroll_rights_tooltip_content:
        "Can't find the infringement reason on the list? You may need to enroll new rights.",
    enroll_rights_now: "Enroll now",
    report: {
        report_code: {
            PPPI1:
                "The product offered is forged and infringes my registered trademark (eg my registered trademark applies to non-original product.).",
            PPPI2: "The listing uses my brand illegitimately.",
            PPPI3: "The software offered is pirated / illegal.",
            PPPI4:
                "The offered product reproduces my copyright without authorization (eg reproduction of plastic works, phonograms, audiovisuals and books.).",
            PPPI5:
                "The listing includes, without authorization, original texts on which I have rights.",
            PPPI6:
                "The listing includes, without authorization, original images (eg photographs, designs, drawings, paintings, videos.) about which I have rights.",
            PPPI7:
                "The listing includes my personal image without authorization (eg, portrait, advertising model).",
            PPPI8: "The product offered violates my model or industrial design.",
            PPPI9: "The product offered infringes my patent or utility model.",
            PPPI10: "Product not destined for sale",
            ACUERDO: "Tengo un convenio de regulación sobre este producto.",
        },
    },
    report_variants: {
        title_plural: "Mark as suspicious",
        title_s: "Mark as suspicious",
        subtitle_copy: "Select the type of work or creation",
        subtitle_brand: "Select where the infringement appears",
        subtitle_related: "Actors, singers, musicians, and dancers	",
        subtitle_p: "Select the type of infringement caused by the products. Please note that all variations will be reported for the same reason.",
        subtitle_s: "Select the type of infringement caused by the product.",
        variant: "variant",
        variants: "variations",
        tooltip: "Agrupamos todas las denuncias que hiciste sobre las variantes en un mismo lugar.",
        alert: {
            hasCatalogo: {
                title: "Your selection includes Catalog selling conditions",
                subtitle: "Certain infringements don’t apply to the reports you initiate here about Catalog selling conditions. However, they do apply to reports about traditional selling conditions.",
                subtitle2: "To report Catalog selling conditions, go to the main page of each one and submit your report there."
            },
            allCatalogo: {
                title: "It is not possible to report certain infringements for Catalog selling conditions",
                subtitle: 'Please note that you can’t report Catalog selling conditions for “Illicit use of trademark,” “Image copyright,” or “Personal image copyright” from here. ',
                subtitle2: "To report these infringements, go to the main page of each one and submit your report there."
            }
        }
    },
    report_v2: {
        title: "Mark as suspicious",
        title_plural: "Mark as suspicious",
        subtitle: "Select the type of infringement",
        title_product: "In the product offered",
        title_catalog: "Report an infringement of my rights",
        subtitle_catalog:
            "Applies to the unlawful use of brands, including counterfeit products or original products that use a brand without its authorization",
        title_publication: "In the listing content",
        title_actors: "Actors, singers, musicians and dancers",
        title_producers: "Producers of sound and video recordings",
        title_broadcastingorganizations: "Broadcasting organizations",
        report_code: {
            PPPI1: "It is a counterfeit product",
            PPPI2: "Illegal use of my trademark",
            PPPI3: "Software",
            PPPI4: "Copyright infringement",
            PPPI5: "Books",
            PPPI6: "Images / photos",
            PPPI7: "Unauthorized use of photographic portrait",
            PPPI8: "Infringes industrial designs or models",
            PPPI9: "Infringes patents, utility models or plant breeder's rights",
            PPPI10: "It is a product not meant for sale",
            PPPI11: "Courses",
            PPPI12: "Video games",
            PPPI13: "Videos",
            PPPI14: "Videos / Movies",
            PPPI15: "Music",
            PPPI16: "Characters",
            PPPI17: "Others",
            PPPI18: "Illegal reproductions",
            PPPI19: "Personal image",
            PPPI20: "Unauthorized use of audio material",
            PPPI21: "Unauthorized use of audiovisual material",
            PPPI22: "Illegal signals",
            PPPI23: "Illegal device",
            PPPI24: "Product Photography",
            ACUERDO: "I have a regulatory agreement on this product.",
            PPPI1_subtext:
                "It is a product that has my trademark, but I have not manufactured it.",
            PPPI2_subtext:
                "Includes my logo in the images with no authorization. Identifies the product with a name or logo that can be confused with my trademark.",
            PPPI3_subtext:
                "The listing offers a computer program that violates my copyrights.",
            PPPI4_subtext:
                "For example, pdf books, compiled music, copies of movies, products that include images of protected works.",
            PPPI5_subtext:
                "The listing offers a literary work that violates my copyrights.",
            PPPI6_subtext:
                "The listing has images or photos that infringe my copyrights.",
            PPPI7_subtext:
                "For example, a photo that shows a person without their authorization.",
            PPPI8_subtext:
                "Describe here the possible infringements to your registered industrial design or models, including designs, forms and monograms.",
            PPPI9_subtext: "",
            PPPI10_subtext:
                "E.g.: free samples or products that were given under commodatum arrangement. Products not officially launched In Brazil, could also be reported.",
            PPPI11_subtext:
                "The listing offers a course that violates my copyrights.",
            PPPI12_subtext:
                "The listing offers a video game that violates my copyrights.",
            PPPI13_subtext: "",
            PPPI14_subtext:
                "The listing offers an audiovisual work that violates my copyrights.",
            PPPI15_subtext:
                "The listing offers musical content that violates my copyrights.",
            PPPI16_subtext:
                "The listing offers products that include my unauthorized characters.",
            PPPI17_subtext:
                "The listing offers other types of work (cartoon, painting, sculpture etc.) that violates my copyrights.",
            PPPI18_subtext: "Unauthorized inclusions or reproductions.",
            PPPI19_subtext:
                "Unauthorized use of my rights of publicity associated with my artistic interpretation.",
            PPPI20_subtext: "Music or recorded sounds.",
            PPPI21_subtext:
                "Movies, series, videos and recitals, concerts and sport events recordings.",
            PPPI22_subtext: "Services to access signals illegally.",
            PPPI23_subtext: "Devices that illegally capture access signals.",
            PPPI24_subtext: "The listing displays official or Catalog photos without authorization from the trademark holder.",

            ACUERDO_subtext: "",
        },
        catalog_code: {
            PPPI1: "It is a counterfeit product",
            PPPI2: "Unlawful use of my brand in the listing.",
            PPPI10: "It is a product that is not destined to be sold",
            PPPI1_subtext:
                "It is a product that carries my brand but was not manufactured by me.",
            PPPI2_subtext:
                "It identifies the product with a name or logo that can be mistaken for my brand, my brand is mentioned when the product does not belong to it, etc.",
            PPPI10_subtext:
                "E.g.: free samples or products that were delivered on loan. Products that were not officially launched in Brazil can also be reported.",
        },
        step_2: {
            header: "Anything else to add?",
            header_images: "Why are you reporting these images?",
            subheader_images: "Explain what intellectual property right is being infringed in the reported images.",
            docs_title: "Attached documentation",
            docs_subtitle: "Select the document with the attached images you will use to support your case.",
            title: "Add comment",
            subtitle: "(Optional)",
            placeholder:
                "Include details about the infringement. The reported seller will be able to read your comments.  ",
            count: "The report will apply for ",
            countStrong: "${count} variations",
            pppi8_subtitle: "Fill in the following information to report a possible infringement of your registered design.",
            pppi8_field1_label: "Indicate the registration number for which you are filing the complaint",
            pppi8_field1_placeholder: "E.g.: AR-123456, EU-78910, etc.",
            pppi8_field1_note: "Current registration number.",
            pppi8_error_reg_number: "Error loading the registration number",
            pppi8_field2_label: "Describe which parts of your design are protected and how they differ from other common designs on the market",
            pppi8_field2_placeholder: "E.g.: The curved handles and diagonal pattern are distinctive compared to common cup designs.",
            pppi8_field3_label: "Indicate which parts of your design were copied in the reported product, detailing the specific similarities",
            pppi8_field3_placeholder: "E.g.: The shape of the base and body proportions match, creating the same general impression.",
        },
        message_advice: {
            title: "IMPORTANT",
            message:
                "Please note that your report must be based on intellectual property infringements related to the Brand Protection Program. Any misuse can result in sanctions to your account.",
            message_strong:
                "The inadequate use of this tool can lead to santions in your account.",
            link: "Find out what you can report",
        },
        tooltip_PPPI10: {
            title: "NEW!",
            description:
                "Use this reason to report infractions of registered trademark over the product.",
        },
        step_1: {
            copyright: "Infringes copyrights",
            copyright_fotoproducto: "Product photography copyright infringement",
            brand: "Infringes trademark rights",
            personal_image: "Uses my personal image without authorization",
            utility_model: "Infringes industrial designs or models",
            patent: "Infringes patents, utility models or plant breeder's rights",
            agreements: "I have a regulatory agreement on this product.",
            related_rights: "Infringes related rights",
        },
        "select-options": {
            subtitle: "Where is the infringement?",
            placeholder: "Select an option",
            "opt-title": "Title",
            "opt-description": "Description",
            "opt-sheet": " Product specification sheet",
            "opt-publish": "Listing",
            subtitle2: "Tell us more about the infringement",
            placeholder2: "Include the details of the infringement here.",
            button: "Send Report",
        },
        buybox: {
            title: "Done! Thanks for reporting",
            description:
                "We processed your report. It will be reviewed and we will reply to you by email.",
            "case-number": "Case number: ",
        },
        product_subtext_1: "Selecciona esta opción si el producto",
        product_subtext_2: "usa tu marca sin autorización",
        publication_subtext_1: "Selecciona esta opción si la publicación",
        publication_subtext_2: "menciona tu marca",
        publication_subtext_3:
            "en el titulo, en la ficha técnica o en la descripción.",
        related_rights_sub: "Review where the infringement is.",
        copyright_sub: "",
        brand_sub: "",
        personal_image_sub: "",
        utility_model_sub:
            "Describe here the possible violations to your registered industrial design or models, including designs, forms and monograms.",
        patent_sub: "",
        agreements_sub: "",
        copyright_title: "Select the type of work or creation",
        copyright_selected: " in ${reason}",
        utility_patent_selected: " of ${reason}",
        image_hub_title: "Indicate which image(s)/photo(s) may be infringing your rights",
        catalog_title: "In the offered product",
        catalog_PPPI10_title: "In the listing’s content",
        "tooltip-isDenounced": "This product was already reported",
        errorDenounce: "Something went wrong. Please try again.",
    },
    datatables: {
        length_menu: "Display _MENU_ records per page",
        zero_records: "Nothing found",
        info: "Showing _START_ to _END_ of _MAX_",
        info_empty: "No records available",
        info_filtered: "(filtered from _MAX_ total records)",
        processing: "Load results",
        first: "First",
        last: "Last",
        next: "Next",
        previous: "Previous",
    },
    activerecord: {
        errors: {
            messages: {
                record_invalid: "invalid object -> %{errors}",
                wrong_size: "wrong size (must be %{file_size})",
                size_too_small: "too small (should be at least %{file_size})",
                size_too_big: "too large (must be at least %{file_size})",
                inclusion: "It is not included in the list",
                exclusion: "is reserved",
                invalid: "invalid",
                confirmation: "does not match the confirmation",
                blank: "required",
                empty: "can not be empty",
                not_a_number: "is not a number",
                not_an_integer: "must be an integer",
                less_than: "must be less than %{count}",
                less_than_or_equal_to: "should be less or equal to %{count}",
                greater_than: "must be greater than %{count}",
                greater_than_or_equal_to: "must be greater than or equal to %{count}",
                too_short: {
                    one: "is too short (1 character minimum)",
                    other: "is too short ( %{count} characters minimum)",
                },
                too_long: {
                    one: "is to large (maximum 1 character)",
                    other: "is to large (maximum %{count} characters)",
                },
                equal_to: "must be equal to %{count}",
                wrong_length: {
                    one: "wrong length (must be 1 character)",
                    other: "wrong length (must be %{count} character)",
                },
                accepted: "must be accepted",
                even: "must be an even number",
                odd: "must be an odd number",
                taken: "already registered",
                required: "required",
            },
        },
        models: {
            user: "User",
        },
        attributes: {
            user: {
                email: "Email",
                first_name: "First Name",
                last_name: "Last Name",
                password: "Password",
                password_confirmation: "Password Confirm",
                current_password: "Current Password",
                currency: "Currency",
                locale: "Language",
                update_password: "Update Password",
                field_required: "This field is required",
                error_rewrite_password: "Does not match the password field",
                alert_update_user: "User updated",
                alert_not_update_user: "No changes were made",
            },
        },
    },
    views: {
        pagination: {
            first: "&laquo; First",
            last: "Last &raquo;",
            previous: "&lsaquo; Prev",
            next: "Next &rsaquo;",
            truncate: "&hellip;",
        },
    },
    shared: {
        side_navigation: {
            suggested_listings: "Suggested listings",
            searches: "Search",
            reports: "Reports",
            custom_reports: "Custom reports",
            last_reported_listings: "Report history",
            support: "Support",
            support_help: "Help",
            management_case: "Case management",
            cases_pending: "Open cases",
            cases_closed: "Closed cases",
            sellers: "Sellers",
            sellers_black: "Blacklisted Sellers",
            sellers_white: "Whitelisted Sellers",
            livesearch_reports: "Livesearch Reports",
            articles_to_report: "Report suspicious listings",
            articles_to_report_tooltip_title: "You have reports to send",
            articles_to_report_tooltip_text:
                "Review your suspicious listings and send your reports from here.",
            articles_to_report_tooltip_not_show: "Do not show again",
            support_link: "Support",
            video_instructions: "Instructional videos",
            new_pill: "NEW",
            my_account: "My Account",
        },
    },
    devise: {
        registrations: {
            edit: {
                title: "Auditor profile",
                cancel_button: "Cancel",
                update_button: "Update",
                help_label_password: "(leave blank if you don't want to change it)",
                help_label_current_password:
                    "(we need your current password to confirm your changes)",
            },
        },
        passwords: {
            edit: {
                title: "Change your password",
                change_passwd_button: "Change my password",
                placeholder_password: "New password",
                placeholder_confirm_password: "Confirm new password",
            },
        },
        mailer: {
            reset_password_instructions: {
                hello: "Hello",
                date: "Date",
                requested_link_text:
                    "Someone has requested a link to change your password. You can do this through the link below.",
                link_change_my_password: "Change my password",
                ignore_email_text:
                    "If you didn't request this, please ignore this email.",
                your_passwd_wont_change_text:
                    "Your password won't change until you access the link above and create a new one.",
            },
        },
    },
    terms_and_conditions: "Terms & Conditions",
    privacy_policy: "Privacy Policy",
    reviews: {
        button: "Reviews",
        title_seller_selected: "Product reviews from",
        title_default: "Product reviews",
        subtitle_seller_default:
            "Here you will find the reviews left by those who have bought from each seller.",
        subtitle_seller_selected:
            "Check the reviews left by those who have bought from this seller.",
        subtitle_seller_no_reviews:
            "The seller you selected have not received reviews on their orders yet.",
        all_reviews: "All",
        positives: "Positive",
        negatives: "Negative",
        view_more: "See More",
        view_less: "See less",
    },
    custom_reports: {
        title: 'Reports',
        no_result: 'No results found for this period',
        no_reports: 'No reports have been generated',
        nav: {
            stats: 'Statistics',
            reports: 'Reports',
            generated: 'Generated reports',
            reports_total: 'Total reports:'
        },
        filter_options: {
            country: 'Country',
            auditor: 'Auditor',
            state: 'Status',
            currency: 'Currency',
            lang: 'Language',
            export_pdf: 'Download report',
            select_columns: 'Select columns',
            export_excel: 'Download report'
        },
        metrics_resumen: {
            title_panel: 'Reports panel',
            title_reports: 'Total reports',
            title_removed: 'Removed',
            title_rechazed: 'Rejected',
            title_reactived: 'Reactivated',
            title_progress: 'Pending Review',
            info_progress: 'The report is being processed internally by the system.'
        },
        graph_motivos: {
            title: 'Most reported reasons',
            header_reason: 'Reason',
            header_detail: 'Detail',
            header_report: 'Reports',
            header_percent: 'Percentage'
        },
        graph_country: {
            title: 'Most audited countries',
            header_country: 'Country',
            header_report: 'Reports sent',
            header_percent: 'Percentage'
        },
        list_sellers: {
            title_top_ten: 'Top ten most reported sellers',
            title: 'Most reported sellers',
            header_seller: 'Seller ID',
            header_report: 'Reports received',
            header_location: 'Location'
        },
        modal_print: {
            title: 'Export to',
            filename: 'File name',
            lang: 'Language',
            print: 'Generate',
            report_date_range: 'Report from {{from}} to {{to}}'
        },
        details: {
            header_country: 'Country',
            header_seller: 'Seller',
            header_id: 'Publication ID',
            header_title: 'Publication name',
            header_localPrice: 'Local price',
            header_customPrice: 'Price in',
            header_auditor: 'Auditor',
            header_reason: 'Reason',
            header_status: 'Status',
            header_date: 'Date',
            not_results: 'No results found for your search',
            show: 'Show',
            results_per_page: 'Results per page',
            previous: 'Previous',
            next: 'Next',
            placeholder_search: 'Search by title, seller or ID...',
            price_not_available: 'Not available',
            loading_prices: 'Loading...'
        }
    },
    reportesV2: {
        all: 'All',
        select_columns: 'Select Columns',
        columns: {
            all: 'All',
            country: 'Country',
            seller: 'Seller',
            id: 'Publication ID',
            title: 'Publication name',
            localPrice: 'Local Price',
            usdPrice: 'Price in',
            auditor: 'Auditor',
            reason: 'Reason',
            status: 'Status',
            date: 'Date'
        },
        states: {
            all: 'All',
            removed: 'Removed',
            rejected: 'Rejected',
            reactivated: 'Reactivated',
            in_progress: 'In Progress'
        },
        status_label: {
            removed: 'Removed',
            rejected: 'Rejected',
            reactivated: 'Reactivated',
            in_progress: 'In Progress'
        }
    },
    massiveLoadV2: {
        upload_subtitle: "Upload your Excel file with the listings to report in batch",
        report_subtitle: "Batch upload report",
        error_subtitle: "An error occurred while processing the information",
        title: "Batch upload of suspicious listings",
        back_to_start: "Back to start",
        success_message: "Batch file processed successfully",
        ready_for_batch: "Ready for batch processing",
        sample_data_title: "Sample of loaded data:",
        item_id_label: "Item ID:",
        code_label: "Code:",
        description_label: "Description:",
        more_elements: "... and {{count}} more elements",
        view_details: "View Details",
        invalid_code_format: "Invalid format in code field (line {{line}}): must have only allowed options",
        invalid_description_format: "Invalid format in description field (line {{line}}): must have at least 5 characters and contain only valid characters",
        invalid_excel_format: "Invalid format in Excel:\n\n{{errors}}\n\nPlease correct these errors and reload the file.",
        batch_error: "Error processing batch: ",
        unknown_batch_error: "Unknown error processing batch",
        no_articles_loaded: "Could not load any article that was imported",
        country_found: "Country found",
        countries_found: "Countries found",
        article_validation_failed: "Article with failed validation",
        articles_validation_failed: "Articles with failed validation",
        summary_title: "Summary",
        countries_loaded: "Countries loaded",
        articles_count: "Number of articles",
        errors_by_type: "Number of errors by type",
        not_found: "  - Not found",
        duplicated: "  - Duplicated",
        validation_failed: "  - Validation failed",
        validation_failed_label: "Validation failed",
        blindages: "  - Blindages",
        load_date: "Load date",
        line_number: "Line number",
        raw_field: "Raw field from Excel (not decoded)",
        identified_article: "Identified article",
        report: "Report",
        description: "Description",
        all_lines: "All lines",
        item_id: "Item ID",
        reason: "Reason",
        due_date: "Due date"
    }
};

export default en;